export default {
  /* - Menu - */
  section_title_dashboard: 'Dashboard',
  section_title_users: 'Users',
  section_title_transactions: 'Transactions',
  section_title_customers: 'Customers',
  section_title_office_users_list: 'Users',
  section_title_active_users: 'Users',
  section_title_archived_users: 'Users',
  section_title_superadmin_users: 'Users',
  section_title_transactions_charged: 'Transactions',
  section_title_transactions_declined: 'Transactions',
  section_title_transactions_authorizations: 'Transactions',
  section_title_transactions_alternate_label: 'Team transactions',
  section_title_reimbursements_alternate_label: 'Team expenses',

  section_title_budgets: 'Budgets',
  section_title_budget_expense_evolution: 'Budgets',
  section_title_budgets_active: 'Budgets',
  section_title_budgets_archived: 'Budgets',
  section_title_budgets_reimbursements: 'Budgets',
  section_title_budget_members: 'Budgets ',
  section_title_export_settings: 'Ajustes de exportación',
  section_title_export: 'Export',
  section_title_export_create: 'Export',
  section_title_export_table_transactions: 'Export',
  section_title_export_table_expenses: 'Export',
  section_title_export_table_all: 'Export',
  section_title_export_exported: 'Export',
  section_title_user_profile_detail: 'Profile',
  section_title_user_preferences: 'Preferences',
  section_title_user_overview: 'User',
  section_title_user_cards: 'User',
  section_title_user_transactions: 'User',
  section_title_user_budgets: 'User',
  section_title_user_benefits: 'User',
  section_title_user_reimbursements: 'User',
  section_title_superadmin_massive_import_details: 'Massive user import',

  section_title_cards: 'Cards',
  section_title_budget_cards: 'Budget Cards',
  section_title_virtual_cards: 'Member Virtual Cards',
  section_title_physical_cards: 'Member Physical Cards',
  section_title_budgets_transactions: 'Budget Transactions',
  section_title_logs: 'Logs',
  section_title_office_log: 'Logs',
  section_title_cards_log: 'Logs',
  section_title_user_log: 'Logs',
  section_title_webhook_log: 'Logs',
  section_title_company: 'Settings',
  section_title_company_details: 'Settings',
  section_title_transaction_fields: 'Settings',
  section_title_expense_fields: 'Settings',
  section_title_integrations: 'Settings',
  section_title_integration_detail: 'Settings',

  section_title_profile: 'Profile',
  section_title_benefits: 'Benefits',
  section_title_social_benefits: 'Benefits',
  section_title_benefits_users: 'Benefits',
  section_title_merchants_settings: 'Merchant settings',
  section_title_activity_group_settings: 'Merchant settings',
  section_title_reimbursements: 'Expenses',
  section_title_reimbursements_pending: 'Expenses',
  section_title_reimbursements_history: 'Expenses',
  section_title_my_virtual_cards: 'My cards',
  section_title_my_physical_cards: 'My cards',
  section_title_expenses: 'My expenses',
  section_title_transactions_history: 'Transacciones',
  section_title_my_history_reimbursements: 'My expenses',
  section_title_my_charged_transactions: 'My transactions',
  section_title_my_authorizations_transactions: 'My transactions',
  section_title_my_declined_transactions: 'My transactions',
  section_title_my_pending_reimbursements: 'My expenses',
  section_transaction_hover:
    'Transactions for the current month are displayed here',
  section_title_my_transactions: 'My transactions',

  section_title_my_reimbursements: 'My expenses',
  section_title_my_cards: 'My cards',
  section_title_all_cards: 'Team cards',
  /* - Common Terms - */
  USERNAME: 'Introduce your user email',
  USERNAME_EMAIL: 'User email',
  DATE_OF_BIRTH: 'Date of birth',
  EMAIL: 'Email',
  EXPENSE_CENTER: 'Expense center',
  EXPENSE_CENTER_PLACEHOLDER: 'Expense center (optional)',
  IDENTIFIER: 'Identifier',
  IDENTIFIER_PLACEHOLDER: 'Identifier (optional)',

  WORK_EMAIL_PLACEHOLDER: 'Your work email',
  PASSWORD: 'Password',
  PASSWORD_PLACEHOLDER: 'Create a password',
  REPEAT_PASSWORD_PLACEHOLDER: 'Repeat password',
  REPEAT_PASSWORD: 'Repeat Password',
  CURRENT_PASSWORD: 'Current Password',
  NEW_PASSWORD: 'New Password',
  REPEAT_NEW_PASSWORD: 'Repeat your new pasword',
  NAME: 'Name',
  NAME_PLACEHOLDER: 'Your name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  LAST_NAME_PLACEHOLDER: 'Your last name',
  PHONE_NUMBER: 'Phone',
  MOBILE_PHONE_NUMBER: 'Mobile Phone',
  PHONE_PREFIX: 'Prefix',
  STATE: 'Province',
  PASSCODE: 'Passcode',
  CITY: 'City',
  ADDRESS: 'Address',
  ADDRESS_PLACEHOLDER: 'Number, Street ...',
  ZIP: 'Zip Code',
  ROLES: 'Role',
  COUNTRY: 'Country',
  USERS_KEYWORD: 'Users',
  OTP: 'One Time Password',
  CURRENCY: 'Currency',
  STATUS: 'Status',
  USER: 'User',
  BUDGETS: 'Budget',
  MEMBERSHIP_STATUS: 'Membership',
  ROLE_ADMIN: 'Admin',
  ROLE_ADMIN_OWNER: 'Account holder',
  ROLE_ACCOUNT_HOLDER: 'Account holder',
  ROLE_BOOKKEEPER: 'Bookkeeper',
  ROLE_REGULAR: 'Regular',
  ROLE_COMMERCIAL: 'Commercial',
  ROLE_SUPER_BOOKKEEPER: 'Super bookkeeper',
  ROLE_BUDGET_OWNER: 'Budget owner',
  FORGOT_PASSWORD: 'I Forgot My Password',
  FILTERS: 'Filters',
  COLUMNS: 'Columns',
  FILTER_AMOUNT_FROM: 'Amount from',
  FILTER_AMOUNT_TO: 'Amount to',
  FILTER_FROM: 'From',
  FILTER_TO: 'To',
  OFFICE_INFORMATION: 'Company information',
  OFFICE_TOTAL_EMPLOYEES: 'Nº of employees',
  OFFICE_USERS_TO_INVOICE: 'Min. number to be invoiced',
  IMPERSONATE_BAR_TEXT:
    'You are impersonating {userName} {userLastName} <email: {email}>',
  ACTION_IMPERSONATE_STOP: 'Stop Impersonating',
  ACTIONS_LABEL: 'Actions',
  ACTION_EDIT: 'Edit',
  ACTION_SAVE: 'Save',
  ACTION_SAVE_CHANGES: 'Save changes',
  ACTION_DELETE: 'Archive',
  ACTION_REMOVE: 'Remove',
  ACTION_REMOVE_ALT: 'Remove',
  ACTION_RESTORE: 'Restore',
  ACTION_CREATE: 'Create',
  ACTION_CONTINUE: 'Continue',
  ACTION_ACCEPT: 'Accept',
  ACTION_REJECT: 'Reject',
  ACTION_SEND: 'Send',
  ACTION_SENDING: 'Sending...',
  ACTION_CONFIRM: 'Confirm',
  ACTION_GO_BACK: 'Volver',
  ACTION_LOGIN: 'Login',
  ACTION_LOGOUT: 'Logout',
  ACTION_LOAD_MORE: 'Load More',
  ACTION_SEARCH: 'Search...',
  ACTION_CLEAR: 'Clear',
  ACTION_FILTER: 'Filter',
  ACTION_CHECK: 'Check...',
  ACTION_SIGN_UP: 'Update',
  ACTION_DOWNLOAD: 'Download',
  ACTION_COPY_TO_CLIPBOARD: 'Copied to clipboard',
  ACTION_EXPORT_IN_PROGRESS: 'Exporting...',
  ACTION_UPDATE: 'Update',
  ACTION_CANCEL: 'Cancel',
  ACTION_CONTACT_US: 'Contact us',
  ACTION_READ_MORE: 'read more',
  ACTION_BILL_CLIENT: 'Bill client',
  ACTION_RELOAD: 'Reload webpage',
  ACTION_CLICK_HERE: 'Click aquí',
  ACTION_ADD_RECEIPT: 'Add receipt',
  ACTION_NEXT_STEP: 'Next',
  ACTION_RETURN_TO_LOGIN: 'Return to login',
  ACTION_SIGN_UP_ACCOUNT: 'Sign up',
  ACTION_REINVITE: 'Resend invitation',
  ACTION_REINVITING: 'Resending invitation',
  ACTION_ALSO_CLOSE: 'Also close',

  RET_FLEX_KEY: 'Flexible retribution',
  BENEFITS_KEY: 'Social benefits',
  DEVOLUIVA_KEY: 'Devoluiva',

  MULTISELECT_DEFAULT_SELECT_LABEL: 'Select',
  MULTISELECT_DEFAULT_SELECTED_LABEL: 'Selected',
  MULTISELECT_DEFAULT_DESELECT_LABEL: 'Remove Selected',
  MULTISELECT_DEFAULT_NO_OPTIONS: 'No options available',
  MULTISELECT_DEFAULT_NO_RESULTS: 'No results found',
  MULTISELECT_OPTION_LABEL_ALL: 'All',
  MULTISELECT_OPTION_LABEL_RECENT: 'Recently used',

  ID: 'ID',
  ACTION_DOWNLOAD_APP: 'Download the app for smartphones',
  AND: 'and',
  SUPPORT_EMAIL: 'customer.support@getfuell.com',
  OR_KEYWORD: 'Or',
  G_AUTOCOMPLETE_DEFAULT_PLACEHOLDER: 'Introduce country, city or street...',

  /* ----- LOGIN ----- */
  login_welcome_fuell: 'Login to your account ',
  login_download_apps: 'Download the apps',
  /* - Snackabr Login Messages - */
  login_action_login_snackbar_error:
    'Whoops! Something went wrong while trying to login',
  login_action_accept_invitation_success:
    'You are all set! Remember to download the app in your smartphone to start working with Fuell',
  login_action_accept_invitation_error:
    'Whoops! Something went wrong while trying to accept the invitation',
  login_action_request_reset_password_info:
    'Reset password has been requested, check your email and follow the instructions',
  login_action_request_reset_password_error:
    'Whoops! Something went wrong while trying to request reset of password: ',
  login_action_reset_password_success:
    'Your password has been successfuly changed',
  login_action_reset_password_error:
    'Whoops! Something went wrong while trying to reset your password: ',
  login_action_impersonate_user_info: 'You are impersonating {user}',
  login_action_impersonate_user_error:
    'Whoops! Something went wrong while trying to imperstonate the user',
  login_action_stop_impersonation_info: 'Impersonating has been stopped',
  login_already_a_user_redirect: 'Already have a Fuell account?',
  login_already_a_user_redirect_login_link: 'Login',
  login_action_login_snackbar_error_invalidad_credentials:
    'Whoops! Something went wrong while trying to login: Incorrect username or password',
  /* ------------------- */
  /* - Remember Password  - */
  login_password_rem_button: 'Forgot your password?',
  login_password_rem_greeting: 'Reset your password',
  login_password_rem_sent: 'Check your email',
  login_password_rem_error: 'The email address you entered is not registered',
  login_reset_password_form_submit: 'Reset Password',
  login_forgot_password_instructions:
    "Fill the data and we'll email you instructions on how to reset it",
  /* -- DASHBOARD -- */
  dashboard_user_greeting: 'Hello {user}!',
  dashboard_balance_card_title: 'Balance',
  dashboard_balance_available: 'Available',
  dashboard_balance_withheld: 'Withheld',
  dashboard_balance_card_wiretransfer_recharge: 'Recharge by wiretransfer',
  dashboard_balance_card_fast_recharge: 'Fast recharge',
  dashboard_account_box_statment_period: 'Statement Period',
  dashboard_account_box_payment_cycle: 'Payment Cycle',
  dashboard_account_box_payment_cycle__monthly: 'Monthly',
  dashboard_account_box_payment_due_date: 'Payment due date',
  dashboard_account_box_make_payment_wire_transfer_title:
    'Add money by wire transfer',
  dashboard_account_box_make_payment_text_1:
    'Add money by making a transfer from any bank with the following details.',
  dashboard_account_box_make_payment_text_2:
    'We recommend a regular monthly transfer. It will take 24h-48h',

  dashboard_account_box_make_transfer_fetch_info_error: 'We were not able to get the payment transfer information, please try again later.',
  dashboard_account_box_make_card_payment_text:
    'Add money instantly using a credit card from any bank.',
  dashboard_make_payment_bank_account: 'Bank Account Number',
  dashboard_make_payment_bank_transfer_subject: 'Subject',
  dashboard_make_payment_bank_account_holder: 'Transfer Target',
  dashboard_make_payment_bank_swift_code: 'Swift Code',
  dashboard_account_box_payment_history_action: 'Top up history and invoices',
  dashboard_account_box_movements_header: 'Top up history',
  dashboard_movements_modal_zero_results:
    "You don't have any top up record yet",

  dashboard_card_payment_title: 'Fast top-up',
  dashboard_card_payment_button: 'Top-up',
  dashboard_card_create_and_payment_button: 'Add card and top-up',
  dashboard_card_payment_your_balance_will_be: 'Your balance will be',
  dashboard_card_payment_add_card: 'New card',
  dashboard_card_payment_save_card: 'Save card',
  dashboard_card_payment_selected_card: 'Selected card',
  dashboard_card_payment_selected_card_placeholder: 'Select a card',
  dashboard_card_payment_selected_card_no_cards: 'No credit cards',
  dashboard_card_payment_selected_card_no_results:
    'No credit cards for current search',

  dashboard_card_payment_faq: 'Check the restrictions for fast top ups {link}',
  dashboard_card_payment_faq_link: 'https://www.notion.so/factorialco/Haz-recargas-en-Fuell-12d0a6c82b3a4c24a481edeb2ed3881e',
  dashboard_card_payment_faq_click_here: 'here',
  dashboard_make_card_payment_modal_delete_card_confirm: 'The card with the 4 last digits {cardLastDigits} will be removed, press Remove card to continue or Cancel to return',
  dashboard_make_card_payment_modal_delete_card_confirm_header: 'Remove card',

  dashboard_card_payment_error:
    'Whoops! Something went wrong while trying to do the payment',

  dashboard_card_payment_success_title: 'Funds added!',
  dashboard_card_payment_failed_title: 'There was an error',
  dashboard_card_payment_success_message: 'Your balance is',
  dashboard_card_payment_failed_message: 'Funds could not be added.',
  dashboard_card_payment_failed_support: 'Contact support for more information',
  dashboard_card_payment_failed_reasons: 'Top-up limits may have been exceeded:',
  dashboard_card_payment_failed_reasons_1: 'Card per day: £3,000',
  dashboard_card_payment_failed_reasons_2: 'Company per day: 5.000€',
  dashboard_card_payment_failed_reasons_3: 'Company per 7 calendar days: 6.000€',
  dashboard_card_payment_failed_reasons_4: 'Company for the previous 30 calendar days: €9.000',

  dashboard_top_up_history_action_download_invoice: 'Download invoice',
  office_fetch_issuer_balance_error:
    'Whoops! Something went wrong while trying to fetch your balance information',
  dashboard_fetch_movements_error:
    'Whoops! Something went wrong while trying to fetch the top up history',
  dashboard_download_invoice_error:
    'Whoops! Something went wrong while trying to download the invoice',
  office_fetch_tokenized_cards_error:
    'Whoops! Something went wrong while trying to fetch stored cards',
  office_delete_tokenized_cards_error:
    'Whoops! Something went wrong while trying to delete the card',

  /* Dashboard tasks keys */
  dashboard_tasks_title: 'Your tasks',
  dashboard_team_tasks_title: 'Team tasks',
  dashboard_task_list_incomplete_tasks: 'Incompleted transactions',
  dashboard_task_list_not_reviewed_tasks: 'Pending review transactions',
  dashboard_task_list_incompleted_reimbursements_tasks:
    'Incompleted expenses',
  dashboard_task_list_not_reviewed_reimbursements_tasks:
    'Pending review expenses',
  dashboard_task_completed_title: 'You have no tasks left!',
  dashboard_task_completed_body:
    'You have completed all pending aprobations',
  dashboard_task_completed_body_navigate:
    'Good job! You may {link} to check all of your expenses',
  dashboard_card_payment_make_payment_invalid_amount:
    'Please, introduce an amount greater than 0 to continue',
  dashboard_card_payment_make_payment_invalid_card:
    'Please, select a card or the option New card to continue',

  dashboard_task_period_current_month: 'Current month',
  dashboard_task_period_current_week: 'This week',
  dashboard_task_period_current_quarter: 'Current quarter',
  dashboard_task_period_current_year: 'This year',
  dashboard_task_period_history: 'Historic',
  dashboard_task_list_notification_link: 'Send notification of pending tasks',

  // NOTIFICATION TASKS MODAL
  send_notification_tasks_modal_title: 'Send notification',
  send_notification_tasks_modal_message: 'We will send a notification from you to users with the type of pending tasks you select.',
  send_notification_tasks_confirm_modal_message: 'Are you sure you want to send notifications? Remember that abusing this function may cause employees to ignore the alerts.',
  send_notification_tasks_confirm_modal_message_send: 'Yes, send',
  send_notification_tasks_modal_message_radio_title: 'Type of notification to send',
  send_notification_tasks_modal_message_radio_message: 'Select which notification you want to send',
  send_notification_tasks_modal_radio_complete: 'Complete expenses in ',
  send_notification_tasks_modal_radio_review: 'Review expenses',
  send_notification_tasks_modal_radio_complete_italic: 'Missing information',
  send_notification_tasks_modal_radio_review_italic: 'Pending review',
  send_notification_tasks_modal_message_send: 'Send notification',

  /* - Dashboard graphic keys - */
  dashboard_graphic_merchant_filter: 'Filter by merchant',
  dashboard_graphic_date_selector_filter: 'Filter by period',
  dashboard_selector_group_by: 'Group by:',
  dashboard_graphic_group_selector_delimited_by_expense_type: 'Total expenditure',
  dashboard_graphic_group_selector_delimited_by_budget: 'Expenditure by budget',
  dashboard_graphic_group_selector_delimited_by_category: 'Expenditure by category',
  dashboard_graphic_expenses_group_by_month: 'Expenses by month',
  dashboard_graphic_expenses_group_by_day: 'Expenses by day',
  dashboard_graphic_date_selector_filter_today: 'Today',
  dashboard_graphic_date_selector_filter_last_seven_days: 'Last 7 days',
  dashboard_graphic_date_selector_filter_last_thirty_days: 'Last 30 days',
  dashboard_graphic_date_selector_filter_last_year: 'Last year',
  dashboard_graphic_date_selector_filter_current_year:
    'Current year (from January to today)',
  dashboard_graphic_date_selector_filte_custom_range: 'Customize date range...',
  dashboard_graphic_date_selector_range_from: 'from',
  dashboard_graphic_date_selector_range_to: 'to',
  dashboard_graphic_group_selector_group_by_days: ' Group by day',
  dashboard_graphic_group_selector_group_by_month: 'Group by month',
  /* Dashboard insights keys */

  dashboard_insight_header_people: 'Expenses made by employees',
  dashboard_insight_header_mileage: 'Expenses by mileages',
  dashboard_insight_header_budgets: 'Expenses by budgets',
  dashboard_fetch_people_insight_error:
    'Whoops! Something went wrong while triying to get expenses per person',
  dashboard_fetch_mileage_insight_error:
    'Whoops! Something went wrong while trying to get the expenses on mileages',
  dashboard_fetch_budget_insight_error:
    'Whoops! Somethign went wrong while tryign to get the expesnes per budget',
  dashboard_insight_expense_word: 'Expenses made',
  dashboard_insight_card_table_header_name: 'Name',
  dashboard_insight_card_table_header_spent_percentage: '% Spent',
  dashboard_insight_card_table_header_spent_in_current_month: 'Month Spent',
  dashboard_insight_card_table_header_spent_percentage_change: '% Change',
  dashboard_insight_card_table_header_transactions_amount: 'Transactions',
  dashboard_insight_card_table_header_transactions_missing_info:
    'Missing information',
  dashboard_insight_card_table_header_transactions_not_reviewed:
    'Needs revision',
  dashboard_insight_card_table_no_data:
    "We don't have any data to show you just yet, but it will be shown in here!",

  /* ------- USERS ---------- */
  users_invite_massive_upload: 'Massive upload',
  users_user_export: 'Export users',
  users_user_export_file: 'User list {exportDate}',

  users_users_section_header: 'Users',
  users_add_user: '+ Add User',
  users_expense_type_label: "User's form of expenditure'",
  users_expense_type_label_optional_cards: 'You may choose whether the user will use virtual cards, a physical card that will be sent to the user, or  if the user may  upload expenses to the platform manually.',
  users_expense_type_label_cards: 'You may choose whether the user will only use virtual cards or use a physical card that will be sent to the user.',
  users_import_users: 'Import Users',
  users_import_users_description:
    'You can massively invite users from your team by downloading {downloadLink}. Fill it up with the necessary data and upload it here.',
  users_import_optional_card_warning:
    'Please, check that all required information is filled up properly. If a cell of the column "Tarjeta" remains with no data, a physical card will be issued for the user',
  users_import_invalid_file:
    'The file you have selected is invalid, ensure you are using our template',
  users_import_invalid_users:
    'Following users are invalid, solve the problems in your file and upload it again to continue.',
  users_import_violation_email_already_in_use: 'E-mail already in use',
  users_import_violation_invalid_email: 'Invalid e-mail address',
  users_import_violation_no_name: 'No name',
  users_import_violation_no_role: 'No role',
  users_import_violation_email_already_in_use_on_import:
    'E-mail repeated in the file',
  users_import_confirm_intro:
    'This is the information we have extracted from your file. Check that the information is correct and then press continue',
  users_import_button_wrong_file: 'I selected the wrong file',
  users_import_table_name: 'Name',
  users_import_table_email: 'E-mail',
  users_import_table_issue: 'Issue',
  users_import_table_gross_salary: 'Gross Salary',
  users_import_table_role: 'Role',
  users_import_table_card_emission: 'Card',

  users_import_select_file_text:
    'Drag your file here or click to select it from your machine',
  users_import_selected_file_intro:
    'We are going to process the file and verify that everything is fine.',
  users_import_invitations_sent: '✅ Invitations has been sent to the users',
  users_import_invitations_waiting_approval:
    'Thank you, we are processing you request.',
  users_import_invitations_waiting_approval_contact:
    'Contact us by chat if you need help.',
  users_import_confirm_modal_message:
    'You are going to add {count} users which are, {regular} regular users and {bookkeeper} bookkeepers',
  users_import_loading_error: 'There was an error loading the data',
  users_import_accept_error:
    'There was an error creating the users or sending the invitations',
  users_import_accept_completed: 'Users has been created and invitations sent',
  users_import_reject_error:
    'There was an error rejecting the user import request',
  users_import_reject_completed: 'User import request was rejected',
  users_import_validation_description:
    'The company wants to import following users:',
  users_import_already_completed: 'User import has already been done',
  users_tab_section_active: 'Active',
  users_tab_section_archived: 'Archived',
  users_user_signup_button: 'Invite Users',
  users_invite_user: 'Invite user',
  users_user_signup_section_send_invites: 'Send Invites',
  users_customers_admin_impersonate_customer_admin: 'Impersonate Admin',
  users_customers_admin_impersonate_user: 'Impersonate user',
  users_user_invitation_request_card: 'Request card',
  user_status__INVITE_BY_SUPER_ADMIN: 'Pending',
  user_status__INVITE_BY_ADMIN: 'Pending',
  user_status__ACTIVE: 'Activated User',
  user_status__ARCHIVE: 'Archived User',
  user_status__DELETED: 'Deleted User',
  user_role__ROLE_ADMIN: 'Admin',
  user_role__ROLE_ADMIN_OWNER: 'Account holder',
  user_role__ROLE_ACCOUNT_HOLDER: 'Account holder',
  user_role__ROLE_COMMERCIAL: 'Commercial',
  user_role__ROLE_BOOKKEEPER: 'Bookkeeper',
  user_role__ROLE_REGULAR: 'Regular',
  user_role__ROLE_SUPER_ADMIN: 'Superadmin',
  user_role__ROLE_SUPER_BOOKKEEPER: 'Super bookkeeper',
  user_role_help_text: 'What role is the most appropriate?',
  user_role_read_more: 'Read more.',

  /* - Customer Terms - */
  customer_creation_header: 'Add Customer',
  customer_information_header: 'Society',
  customer_creation_social_reason: 'Social Reason',
  customer_creation_invite_customer: 'Invite',
  customer_update_customer_types: 'Update price list',
  customer_creation_registration_number: 'CIF Number',
  customer_creation_social_or_billing_information:
    'Social Address / Billing Address',
  customer_creation_fuell_admin_data: 'Fuell account admin',
  customer_creation_office_admin_header: 'Office Administrator Information',
  customer_creation_card_record: 'Card engraved',
  customer_creation_card_company_name_on_record: 'Company name on card',
  customer_creation_card_send_address: 'Card send address',
  customer_creation_office_other: 'Other information',
  customer_creation_office_configuration: 'Company settings',
  customer_creation_office_card_usage: 'Company usage of cards',
  customer_creation_office_card_usage_tooltip:
    'Choose if the company will or will not use the card, or give the option for the company admin to select if the users will use or not a card. By default, companies are created with cards if not indicated',
  customer_creation_zoho_pricing_plan: 'Pricing plan',
  customer_creation_zoho_pricing_plan_tooltip:
    'Select a pricing plan for this company. This plans need to be created beforehand on Zoho in order for them to be listed. The information will be generated on Zoho after the admin has finished the onboarding process.',
  customer_onboarding_header: 'Onboarding',
  customer_onboarding_type__STANDARD: 'Normal',
  customer_onboarding_type__SELF_ONBOARD: 'Web',
  customer_onboarding_type__WITHOUT_CUSTOMER: 'App',

  customer_new_customer_user_to_invoice: 'Minimum amount of users to bill',
  customer_new_customer_billing_starts_at: 'Start billing on',
  customer_new_customer_billing_starts_at_placeholder: 'Select billing start date',
  customer_new_customer_devoluiva: 'Activate DevoluIVA for this company',
  customer_new_customer_allow_shipping_address: 'Send all the cards from this company to this address',
  customer_new_customer_allow_shipping_address_info: 'If checked, the users from this company will not be able to select an address for the reception of the cards and all card will be sent to the specified address',

  customer_creation_fuell_attorney_data: 'Fuell account authorised representative',
  customer_new_customer_attorney_document: 'ID (DNI...)',
  customer_new_customer_attorney_date_of_birth: 'Date of birth',
  customer_convert_to_card_user_document_expiration_date: 'DNI Expiration date',

  customer_creation_fuell_admin_card_usage: 'Card usage',
  customer_creation_fuell_admin_card_type_emission: 'Card type to emit',
  customer_creation_fuell_admin_card_usage_tooltip:
    'Only if the company has optional usage of cards, select if the admin will or  will not have a Fuell card',
  customer_creation_office_header: 'Office Information',
  customer_creation_office_contact_person: 'Person of Contact',
  customer_creation_office_board_members: 'Board Members',
  customer_creation_office_current_balance: 'Current Balance',
  customer_creation_office_balance_alert_threeshold: 'Balance Alert Threshold',
  customer_list_table_header_name: 'Customer Name',
  customer_list_table_header_registration_number: 'Registration Number',
  customer_list_table_header_customer_office_admin: 'Admin',
  customer_list_table_header_customer_client_type: 'Customer Type',
  customer_list_table_header_customer_office_admin_status: 'Admin Status',
  customer_list_table_header_customer_card_usage_type: 'Card emission',
  customer_status_ACTIVE: 'Activated Customer',
  customer_status_ARCHIVED: 'Archived Customer',
  customer_actions_modal_header: 'Customer Actions',
  customer_actions_modal_customer_actions: 'Company actions',
  customer_actions_modal_customer_information: 'Company information',
  /* customer billing terms  */
  customers_bill_client_header: 'Customers billing',
  customers_bill_client_amount: 'Amount',
  customers_bill_client_message:
    'You are about to place a charge for the customer {customerName}, fill the amount and your passcode to proceed',
  customers_bill_client_action: 'Bill customer',

  customers_bill_client_success: 'Charge placed successfully correctamente',
  customers_bill_client_error:
    'Whoops! Somethign went wrong while trying to place the charge for the customer',
  customers_confirm_archive_header_action: 'Archive customer',
  customers_confirm_activate_header_action: 'Activate customer',
  customers_confirm_toggle_archive_customer_status:
    'You are about to archive the customer {customerName}, to continue, press Archive customer, otherwise press Cancel',
  customers_confirm_toggle_activate_customer_status:
    'You are about to activate the customer {customerName}, to continue, press Activate customer, otherwise, press Cancel',

  customers_user_actions_reequest_card: 'Request card sending',
  customers_user_cards: 'Cards',
  customer_user_without_cards: 'User without cards',
  customer_user_with_virtual_cards: 'User with virtual cards',
  customer_user_request_physical_card: 'Request a physical card',
  customer_user_convert_to_user_with_cards: 'Turn into cards user',
  customer_user_actions_cancel_card: 'Cancel card with MP: {numMP}',
  customer_user_card_not_emmited: 'Not emitted',
  customers_users_request_card_action: 'Request card',
  customers_users_request_card_info: 'You are about to request a card for the user {userName}, fill in the requested information and press request card to continue',
  customers_users_request_card_no_sending_info: 'You are about to request a card for the user {userName}, press Request card to continue.',
  customers_users_request_card_success: 'Card requested successfully',
  customers_users_request_card_summary_info: 'You are about to request a card for the user {userName}. {verify} and press Request card to continue. If you need to change the information press Cancel to edit it',
  customers_users_request_card_summary_info_verify: 'Please, check if the information is correct',

  customers_users_convert_to_card_user_header: 'Convert into a card user',
  customers_users_convert_to_card_user_info: 'You are going to request Pecunpay to register the user {userName} so that the user can use cards. Fill in the information and click on Convert into cards user to continue',
  customers_users_convert_to_card_user_submit: 'Convert into card user',
  customers_users_convert_to_card_user_summary_info: 'You are about to convert the user {userName} into a card user. {verify} and press Convert into card user to continue. If you need to fix the information, press cancel and fix the information.',
  customers_users_convert_to_card_user_summary_info_verify: 'Please make sure the information is correct',

  customers_users_convert_to_cards_user_success: 'We have requested the registration of the user on Pecunpay successfully',
  customers_users_conver_to_cards_user_error: 'Whoops! Something went wrong while trying to request the registration  of the user on Pecunpay',

  customers_users_request_card_error: 'Whoops! Something went wrong while trying to request card',
  customers_users_actions_cancel_card_confirm: 'You are about to cancel the user {userName} card, with MP number, {numMP}. This action cant be undone, if you want to continue, press Cancel card to continue, or Cancel to return',
  customers_users_actions_cancel_card_confirm_action: 'Cancel card',
  customers_users_actions_cancel_card_success: 'Card cancelled successfully',
  customers_users_actions_cancel_card_error: 'Whoops! Something went wrong while trying to cancel the card',
  customer_actions_request_otp: 'This actions needs you to request a One Time Password (OTP). When you prss Request OTP you will receive a one time password on your phone to confirm the action. Type it in and press confirm',
  customer_actions_request_otp_action: 'Request OTP',
  customer_actions_request_otp_warning: 'If it takes more than a minute for you to receive the OTP, request it again by pressing  Request OTP',
  customer_actions_request_otp_in_progress: 'Generating OTP, check your SMS...',
  customer_actions_otp_requested_warning: 'A password has been sent to you by SMS. Use it to confirm the operation. If you have not received anything, request it again',
  customer_action_remove_users: 'Delete all users',
  customers_action_remove_users_confirm_modal_title: 'Confirm delete all users',
  customers_action_remove_users_confirm_modal_body: 'All the users from this company will be deleted. Upon completion an email will be sent to you to confirm the result of the operation. Press confirm to continue.',
  customer_remove_users_action_success: 'You have requested the deletion of all the users successfully',
  customer_remove_users_action_error: 'Whoops! Something went wrong while trying to request the deletion of all users',

  /* Customer Funds Transfer terms */
  customer_action_transfer_funds: 'Bank account funds transfer',
  customer_action_transfer: 'Make a refund',
  customer_action_manage_office_features: 'Manage features',
  customer_action_archive: 'Archive company',
  customer_action_restore: 'Restore company',
  customers_funds_transfer_modal_header: 'Transfer funds to a bank account',
  customers_funds_transfer_modal_confirm_transfer: 'Transfer funds',

  customers_transfer_funds_to_bank_account_message:
    "You are about to transfer funds from the client { customerName} account to a bank account through the client's IBAN account number, fill the information and press send",
  customer_amount_to_transfer: 'Transfer amount',
  customer_transfer_concept: 'Concept',
  customer_transfer_iban_bank_number: 'IBAN Bank account number',
  customer_transfer_beneficiary_name: 'Beneficiary name',

  /* - Users Terms - */
  users_identifier: 'Identifier',
  users_expense_center: 'Expense center',
  users_physical_card_status: 'Physical Card Status',
  users_budgets: 'Budgets',
  user_dni: 'DNI',
  user_list_table_header_invited_on: 'Invited On',
  user_list_table_header_flexible_retribution: 'Flex. Retrib. Food',
  user_list_table_header_gross_salary: 'Gross salary',
  users_create_commercial: 'Create commercial',
  users_superadmin_create_commercial_modal_header: 'Commercial creation',
  users_superadmin_create_commercial_action_create: 'Create commercial',
  users_superadmin_create_commercial_success:
    'Commercial user created successfully',
  users_superadmin_create_commercial_error:
    'Whoops! Something went wrong while trying to create the commercial user',

  users_create_super_book_keeper: 'Create Superbookeeper',
  users_superadmin_create_super_book_modal_header:
    'Create user super bookkeeper',
  users_superadmin_create_superbook_action_create: 'Create Superbookeeper',
  users_superadmin_create_superbook_success:
    'Super bookkeeper created successfully',
  users_superadmin_create_superbook_error:
    'Whoops! Something went wrong while trying to create the super bookkeeper',

  /* -  User Details  - */
  user_detail_action_edit_profile: 'Edit Profile',
  user_detail_action_activate_user: 'Activate User',
  user_detail_action_archive_user: 'Archive User',
  user_detail_tab_overview: 'Overview',
  user_detail_tab_member_cards: 'Cards',
  user_detail_tab_transactions: 'Transactions',
  user_detail_tab_budgets: 'Budgets',
  user_detail_tab_benefits: 'Benefits',
  user_detail_tab_reimbursements: 'Expenses',
  user_detail_toggle_status_confirm_archive_header_action: 'Archive user',
  user_detail_toggle_status_confirm_restore_header_action: 'Activate user',

  user_detail_toggle_status_confirm_archive_warning:
    'You are about to archive the user {user}, to continue, press Archive user, otherwise press Cancel',
  user_detail_toggle_status_confirm_restore_warning:
    'You are about to activate the user {user}, to continue, press Activate user, otherwise press Cancel',
  /* - Self Onboarding  - */
  user_self_onboarding_create_account: 'Create account',
  user_self_onboarding_register_now_label:
    'Sign up and start using our software at no cost',
  user_self_onboarding_sign_up_personal_data: 'Introduce your personal data',
  user_self_onboarding_sign_up_company_data: "Introduce your company's data",
  user_self_onboarding_sign_up_create_security_passcode:
    'Create a security pincode',
  user_self_onboarding_accept_tcs:
    'I have read and accept the {tc},{sc} and {pp}',
  user_self_onboarding_tc: 'Conditions of use',
  user_self_onboarding_sc: 'Services conditions',
  user_self_onboarding_pp: 'Privacy policy',
  user_self_onboarding_company_name: 'Company name',
  user_self_onboarding_complete_onboarding: 'Start using Fuell',
  user_self_onboarding_completed_check_email:
    'You are almost done! Check your email to activate your account',
  user_self_onboarding_completed_repeat_check:
    "If after a few minutes you don't receive the email click {click}",
  user_self_onboarding_cif_number: 'CIF',
  user_self_onboarding_passcode_info:
    'For security reasons, we need you to create a {digitsbolder} in order to access the Fuell app.',
  user_self_onboarding_passcode: 'Security pincode',
  user_self_onboarding_passcode_placeholder: '4-digit pincode',
  user_self_onboarding_repeat_passcode: 'Repeat pincode',
  user_self_onboarding_repeat_passcode_placeholder: 'Repeat pincode',

  user_self_onboarding_error:
    'Whoops! Something went wrong while trying to sign up',

  user_self_onboarding_activation_success:
    'You are all set! Your account has been activated correctly',
  user_self_onboarding_activation_success_redirection:
    '{click} if your browser does not redirect you automatically',
  user_self_onboarding_activation_failure:
    'We had a problem trying to activate your account',
  user_self_onboarding_activation_failure_contact_support:
    'It is possible that your activation link is invalid or has already been used.{customerSupport} so we can help you out',
  user_self_onboarding_activation_failure_message:
    'Hello, I have just tried to activate my account but there has been an error. Could you help me out?',

  /* - Accept Invitation - */
  user_accept_invitation_header: 'Welcome to Fuell',
  user_accept_invitation_body:
    'Fill in the required information and press Send',
  user_invitation_form_complete_registration: 'Create your Fuell account',
  user_invitation_form_identification: 'Identification',
  user_invitation_form_id: 'ID (including letter)',
  user_invitation_form_email_no_spam:
    'We need your mobile phone number to keep your account secure, we will never send you any kind of advertising.',
  user_invitation_form_dni_expiration_date: 'Expiration Date (DD/MM/YYYY)',
  user_invitation_form_select_expiration_date:
    'Select expiration date of your ID',
  user_invitation_form_create_passcode:
    'Hi {name}, create a {digits} digit passcode for your account',
  user_invitation_form_create_passcode_not_card_pin:
    'This is NOT the pin of your card.',
  user_invitation_form_create_passcode_text:
    "We'll ask you for it when you access your virtual card or make account changes. We can't see it either.",
  user_invitation_form_create_passcode_confirmation: 'Confirm passcode',
  user_invitation_form_create_passcode_confirmation_text:
    'Type the same passcode again',
  user_invitation_form_create_passcode_confirmation_not_match:
    "Passcodes doesn't match, try it again",
  user_invitation_form_accept_terms: 'Please read and accept our terms',
  user_terms_accept_label:
    'I have read and accept the ',
  user_terms_accept_label_new:
    'I have read and accept the new ',
  user_invitation_form_token_not_found:
    'This invitation link is not valid or has already been used. If you are already registered, go to the login page in which you may login or recover your password',
  user_accept_invitation_redirect_login: 'Take me to the login page',

  user_invitation_form_token_expired:
    'We found your invitation but after 24h without activation, it has expired, please contact your administrator to reactivate it',
  user_invitation_form_fuell_tos_headers: 'Fuell Terms of Service',
  user_invitation_form_fuell_tos_explanation:
    'General terms for using our service',
  user_invitation_form_fuell_toc_headers: 'Fuell Terms & Conditions',
  user_invitation_form_fuell_toc_explanation:
    'Specific terms for using our plastic and virtual prepaid cards',
  user_invitation_form_fuell_privacy_policy_header: 'Fuell Privacy Policy',
  user_invitation_form_fuell_privacy_policy_explanation:
    'How we keep your private data safe',

  user_invitation_card_send_address: 'Card shipping address',
  user_invitation_card_send_option_send_to_office: 'Send to office',
  user_invitation_card_send_option_send_to_other: 'Send to other address',

  user_terms_general_conditions: 'Terms of Use',
  user_terms_general_conditions_explanation:
    'Conditions of use of the platform',
  user_terms_service_conditions: 'Terms of Service',
  user_terms_service_conditions_explanation:
    'Conditions of the services offered by Fuell',
  user_terms_privacy_policy: 'Fuell`s privacy policy',
  user_terms_privacy_policy_explanation:
    'How we keep your private data secure',
  user_terms_payment_service_conditions:
    'Payment service conditions',
  user_terms_payment_service_conditions_explanation:
    'Payment service provider conditions',

  /* - Profile Section */
  user_profile_personal_details_tab: 'Personal Details',
  user_profile_preferences_tab: 'Preferences',
  user_profile_job_title: 'Job Title',
  user_profile_email: 'Company Email',
  user_profile_create_passcode: 'Create a Passcode',
  user_profile_change_passcode: 'Change your Passcode',
  user_profile_old_passcode: 'Current Passcode',
  user_profile_new_passcode: 'New Passcode',
  user_profile_set_passcode_instructions:
    'Fill the requested information and press Change Passcode to submit',
  user_profile_change_password: 'Change Password',
  user_profile_change_password_message: 'Enter the new four-digit password for the user to access the app',
  user_profile_form_forgot_passcode_action: 'Forgot your passcode?',
  user_action_change_passcode_submit: 'Updating passcode...',
  user_profile_upgrade_to_admin: 'Make admin',
  user_profile_forgot_passcode_modal_header: 'Passcode recovery',
  user_profile_forgot_passcode_explain:
    'To recover your passcode, contact with us on {0}  or by chat',
  user_update_passcode_success: 'Passcode updated successfully',
  users_change_user_password_success: ' Password updated successfully',
  user_profile_picture_updated: 'Profile picture updated',
  user_profile_picture_error:
    'Whoops! Something went wrong updating your profile picture',

  user_profile_change_passcode_passcode_mismatch:
    'The passcodes does not match',
  user_change_user_password_error:
    'Whoops! Something went wrong while trying to change the password',

  user_profile_settings_ACCOUNT_LOW_BALANCE: 'Company balance low',
  user_profile_settings_ACCOUNT_LOW_BALANCE_comment:
    "We'll let you know before your company runs out of funds",
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE: 'New funds available',
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE_comment:
    "We'll let you know whenever your company receives new funds",
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED:
    'Insufficient funds',
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED_comment:
    "We'll let you know when your company's funds are lower than the total balance available for your users",
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END:
    'Transaction closure date nearby',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_comment:
    "We'll let you know 3 days before the monthly closure of the transactions",
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS:
    'Benefits closure nearby',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS_comment:
    "We'll let you know 3 days before the monthly closure of the benefits transactions",
  user_profile_settings_INVITED_TO_BUDGET: 'Invitation to budget',
  user_profile_settings_INVITED_TO_BUDGET_comment:
    "We'll let you know when you are invited to a budget",
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET: 'Assigned funds',
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET_comment:
    "We'll let you know when new funds have been assigned to one of your budgets",
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION: 'Weekly report',
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION_comment:
    "Each week we'll let you know about the transactions you made and which ones are missing information",
  user_profile_settings_AUTHORIZATION_TRANSACTION: 'Purchase authorization',
  user_profile_settings_AUTHORIZATION_TRANSACTION_comment:
    "We'll let you know when a commerce checks if you card is valid to make purchases",
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION: 'Weekly notification of expenses pending review',
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION_comment: "We'll send you weekly notifications letting you know the expenses that are pending review",

  user_profile_settings_language: 'Language',
  user_settings_language__spanish: 'Spanish',
  user_settings_language__english: 'English',
  user_settings_language__portuguese: 'Portuguese',

  user_post_settings_notification_success:
    'Settings have been updated successfully',
  user_post_settings_notification_error:
    'Whoops! Something went wrong while trying to update settings',
  user_set_passcode_success: "User's passcode has been set successfully",
  user_set_passcode_error:
    "Whoops! Something went wrong while trying to set the user's passcode",
  user_update_passcode_error:
    "Whoops! Something went wrong while trying to update the user's passcode",
  user_action_fetch_user_error:
    "Whoops! Something went wrong while trying to get this users's info",
  /* - SnackBars Users Messages - */
  customer_action_create_customer_success:
    'Invitation has been sent to customer',
  customer_action_create_customer_error:
    'Whoops! Something went wrong trying to invite this customer',
  customer_action_fetch_customers_error:
    'Whoops! Something went wrong tyring to fetch the customer list',
  customer_action_update_customer_success:
    'Customer information has been updated successfuly',
  customer_action_update_customer_error:
    'Whoops! Something went wrong trying to update this customer information',
  customer_action_archive_customer_success:
    'Customer has been archived successfully',
  customer_action_archive_customer_error:
    'Whoops! Something went wrong trying to archive this customer',
  customer_action_activate_customer_success:
    'Customer has been activated successfully',
  customer_action_activate_customer_error:
    'Whoops! Something went wrong trying to activate this customer',
  users_action_fetch_users_error:
    'Whoops! Something went wrong trying to fetch the users',
  users_actions_update_user_success:
    'User information has been updated successfully',
  users_actions_update_user_error:
    "Whoops! Something went wrong trying to update the user's information",
  users_actions_send_invitations_success:
    'Invitations has been sent to the users successfully',
  users_actions_send_invitations_error:
    'Whoops! Something went wrong trying to send the invitations',
  users_actions_activate_user_succes: 'User has been activated successfully',
  users_actions_activate_user_error:
    'Whoops! Something went wrong trying to activate the user',
  users_actions_archive_user_success: 'User has ben archived successfully',
  users_actions_archive_user_error:
    'Whoops! Something went wrong trying to archive this user',
  users_actions_fetch_user_budgets_error:
    "Whoops! Something went wrong while trying to fetch this user's budgets",
  /* -------- */
  /* User Finder Selector */
  user_finder_selector_type_to_find: 'Type to find users',
  user_finder_selector_select_member: 'Add User',
  user_finder_selector_no_results: 'No results found, try again',
  /* ------- */

  /* User Actions Modal */
  user_action_cancel_invitation: 'Cancel invitation',
  user_actions_modal_header: 'Details',
  user_actions_modal_information: 'Information',
  user_actions_modal_settings: 'Settings',
  user_actions_modal_user_actions: 'User actions',
  user_actions_modal_card_actions: 'Card actions',
  user_actions_modal_online_payments: 'Online payments',
  users_action_cancel_user_invitation_success:
    'User account has been removed successfully',
  users_actions_cancel_user_invitation_error:
    "Whoops! Something went wrong while trying to cancel this user's invitation",
  users_action_reinvite_user_success: 'We have resent the invitation email successfully',
  users_action_reinvite_user_error: 'Oops! Something went wrong when forwarding the users invitation email.',
  users_actions_confirm_modal_message:
    'You are going to {action} the user {user} - <{email}>, this action is irreversible.',
  user_action_remove_warning: 'remove',
  user_action_cancel_invitation_warning: 'cancel the invitation for',
  users_confirm_cancel_invitation_header: 'Remove invitation',
  users_confirm_remove_user_header: 'Remove user',
  users_confirm_cancel_invitation_confirm_action: 'Remove',
  /* --- */

  /* --- Users Salary --- */
  user_request_gross_salary_title: 'Anual gross salary requested',
  user_request_gross_salary_message:
    'To continue, we need you to type the anual gross salary of the employee',
  user_gross_salary: 'Anual gross salary',
  user_request_gross_salary_error_validation_message:
    ' The minimal gross salary in order to user flexible remuneration is {minimumSalary}.',

  /* -------------------------------- */

  /* -- TRANSACTIONS SECTION -- */

  transactions_transactions_section_header: 'Transactions',
  transactions_transactions_subsection_charged: 'Charged',
  transactions_transactions_subsections_declined: 'Declined',
  transactions_transactions_subsections_authorizations: 'Authorizations',

  transactions_dashboard_transactions_header: 'Transactions',
  transactions_dashboard_total_spent_header: 'Total spent',
  transactions_dashboard_total_missing_info: ' Missing info.',
  transactions_dashboard_total_not_reviewed: 'Needs revision',
  transactions_fetch_transactions_dashboard_error:
    'Whoops! Something went wrong while trying to obtain the data for your transactions',
  transactions_dashboard_total_missing_info_text:
    'Missing information',
  transactions_dashboard_total_not_reviewed_text:
    'Pending review',
  transactions_dashboard_show_transactions: 'Show transactions',
  transactions_status__OK: 'Cleared',
  transactions_status__KO: 'Declined',
  transactions_status__PENDING: 'Pending',
  transactions_status__REVIEWED: 'Reviewed',
  transactions_status__AUTHORIZATION: 'Authorization',
  transaction_status__IS_ACCOUNTED: 'Accounted',
  transactions_status__PROCESSING: 'Processing',

  transactions_categorize_status__COMPLETED: 'Completed',
  transactions_categorize_status__INCOMPLETED: 'Incompleted',
  transactions_categorize_status__INCOMPLETED_large: 'Information incompleted',
  transactions_categorize_status__ALL: 'All',
  transactions_review_flow_step_default: 'Single approval flow',
  transactions_review_flow_step_multilevel: 'Multilevel approval flow',
  transactions_payment_methods: 'Payment methods',
  transactions_payment_method__WIRE_TRANSFER: 'Wire transfer',
  transactions_payment_method__CASH: 'Cash',
  transactions_payment_method__CORPORATE_CASH: 'Corporate cash',
  transactions_payment_method__CORPORATE_CARD: 'Corporate card',
  transactions_payment_method__PERSONAL_CARD: 'Personal card',

  transactions_card_type__MEMBER_PHYSICAL: 'Physical Card',
  transactions_card_type__MEMBER_VIRTUAL: 'Virtual Card',

  transactions_action_export: 'Export',
  transactions_action_download: 'Download',
  transactions_actions_add_expense: 'Add expense',
  transactions_actions_create_expense: 'Expense',
  transactions_actions_create_reimbursement: 'Expense',
  transactions_actions_create_mileage: 'Mileage',
  transactions_actions_create_diet: 'Diet',

  transactions_table_total_count_and_amount:
    'Showing {totalItems} {transactionType} for a total of {transactionTableTotalAmount}.',
  transactions_table_total_count_and_amount_user_type: 'user | users',
  transactions_table_total_count_and_amount_transaction_type: 'transaction | transactions',
  transactions_table_total_count_and_amount_expense_type: 'expense | expenses',

  /* Transactions reimbursements */
  transactions_reimbursements_subsection_pending: 'Pending revision',
  transactions_reimbursements_subsection_history: 'History',

  /* - Transactions explanation labels - */
  transactions_charged_section_explanation:
    "Here you will find all the movements made by the your company's employees with their Fuell cards.",
  transactions_charged_section_expenses_explanation:
    'Here you will find all the movements made by you with your Fuell cards.',
  transactions_authorization_section_explanation:
    "Here you will find the card authorization movements made by your company's employees with their Fuell cards.",
  transactions_authorization_section_expenses_explanation:
    'Here you will find the card authorization movements made by your Fuell cards.',
  transactions_declined_section_explanation:
    "Here you will find all the denied movements made by your company's employees with their Fuell cards.",
  trasnactions_declined_section_expenses_explanation:
    "Here you will find all the denied movements made by your Fuell cards.'",

  /* - Transactions reimbursements explanation labels - */
  transactions_reimbursements_history_explanation:
    "Here you will find all the manual expenses made by your company's employees.",
  transactions_reimbursements_userId_history_explanation: 'Here you will find all transactions made by {userName}',
  transactions_reimbursements_users_history_explanation: 'Here you will find all transactions made by employees',
  transactions_reimbursements_history_expenses_explanation:
    'Here you will find all the manual expenses made by you.',
  transactions_reimbursements_pending_explanation:
    "Here you will find all the manual expenses made by your company's employees that are awaiting for revission",
  transactions_reimbursements_pending_expenses_explanation:
    'Here you will find all the manual expenses made by you that are awaiting revission .',
  transactions_reimbursements_userId_pending_explanation: 'Here you will find all transactions made by {userName}',
  transactions_reimbursements_users_pending_explanation: 'Here you will find all transactions made by employees',
  /* - Charged Transactions - */
  transactions_charged_table_header_status: 'Status',
  transactions_charged_table_header_date: 'Date',
  transactions_charged_table_header_user: 'User',
  transactions_charged_table_header_processing_transactions: 'Transactions in process',
  transactions_charged_table_header_merchant: 'Merchant',
  transactions_charged_table_header_budget: 'Budget',
  transactions_charged_table_header_card: 'Payment method',
  transactions_charged_table_header_card_id: 'Id',
  transactions_charged_table_header_amount: 'Ammount',
  transactions_charged_table_header_receipt: 'Receipt',
  transactions_budget_not_funds_enough: 'Not funds enough',
  transactions_charged_table_header_reimbursable: 'Refundable',
  transactions_charged_table_header_no_reimbursable: 'Not refundable',
  transactions_charged_table_header_total: 'Total',

  cards_table_header_status: 'Status',
  cards_table_header_user: 'User',
  cards_table_header_budget: 'Budget',
  cards_table_header_card_id: 'Id',
  cards_table_header_name: 'Name',
  // RF only:
  transactions_table_activity_group_category: 'Category',

  /* Transaction Export filters */
  transactions_export_reference_date: 'Reference date',
  transactions_export_reference_date_description: 'Select the date of the expenses to be considered for export',
  transactions_export_creation_date: 'Creation date',
  transactions_export_expense_date: 'Date of expense',
  transactions_export_confirmation_date: 'Value date',
  transactions_export_approve_date: 'Date of approval',
  transactions_export_without_date: 'Without date',
  transactions_export_file_format: 'File format',
  transactions_export_file_format_description: 'Select the type of format in which to export',
  transactions_export_date_range_selector_label: 'Date range',
  transactions_export_date_range_selector_placeholder: 'Select date range',
  transactions_export_budgets_selector_label: 'Select budget to export',
  transactions_export_cards_selector_label: 'Select card to export',
  transactions_export_info:
    'Enter the date range, as well as the filters you want. If you enter an email, we will notify you when the download is available, otherwise you can check and download in the "My exports" tab.',
  transactions_export_email_to_notify: 'Email to notify',
  transactions_export_action_export_and_lock:
    'Lock exported transactions to prevent them from being modified.',
  transactions_export_action_export_and_lock_help:
    'You may unlock them, one by one, any time later.',
  transactions_export_holded_config_not_present:
    'In order to export in this format, it is required to set up your Holded configuration , {navigationLink} if you have not done so yet',
  transactions_export_holded_config_click_here: 'click here',
  transactions_export_default_format: 'Normal format',
  transactions_export_holded_format:
    'Holded format (beta version, in testing phase)',
  transactions_export_navision_format:
    'Navision format (beta verion, in testing phase)',

  transactions_export_plexus_format: 'Plexus specific format',
  transactions_export_plexus_with_tickets_format: 'Plexus specific format (with tickets)',
  transactions_export_plexus_without_tickets_format: 'Plexus specific format (without tickets)',
  transactions_export_twentyfour_seven_categories_format: 'Production format by category',
  transactions_export_wrap_file_format: 'Wrap file format',
  transactions_export_smile_file_format: 'Smile Company format',

  transactions_export_talleres_garrido_format: "Talleres Garrido's specific format",
  transactions_export_tecnocarrocera_format: "Tecnocarrocera's specific format",
  transactions_export_rosa_gres_catalonia_ceramica_format: 'Accounting format export',
  transactions_export_custom_mapping_format: 'Custom file',

  transactions_export_tab_export_settings: 'Configure export',
  transactions_export_tab_download_settings: 'Configure download',
  transactions_export_tab_export_history: 'My exports',
  transactions_export_tab_download_history: 'My downloads',
  transactions_export_modal_export_users_explanation:
    "We'll provide you the information separated by users. As it is a complex process, we can't offer you instantly and will process it on our servers. As soon as is ready, we'll notify you in the email you indicate, otherwise you can check the status in the History tab",

  transactions_export_success:
    'Your export report is being processes. If you indicated it, we will let you know by email when it is ready',
  transactions_export_error:
    'Whoops! Something went wrong while trying to process your export report',
  transactions_export_request_export: 'Request export report',
  transactions_export_request_download: 'Request download',
  /* Transaction Export History */
  transactions_export_history_table_header_export_date: 'Date of request',
  transactions_export_history_table_header_export_type: 'Export format',
  transactions_export_history_table_header_export_status: 'Status',
  transactions_export_history_table_header_export_download: 'Download',
  transactions_export_history_download_in_progress: 'Generating download...',

  transactions_export_history_type__NORMAL: 'Normal',
  transactions_export_history_type__COMPLETE: 'By users',
  transactions_export_history_type__HOLDED: 'Holded',
  transactions_export_history_type__NAVISION: 'Navision',
  transactions_export_history_type__BUDGETS: 'Budget/{budget}',
  transactions_export_history_type__PHYSICAL_CARDS: 'Card/{card}',
  transactions_export_history_type__VIRTUAL_CARDS: 'Card/{card}',
  transactions_export_history_type__EXPENSES_TRANSACTIONS: 'Expenses/Transactions',
  transactions_export_history_type__EXPENSES_REFUNDS: 'Expenses/Refunds',
  transactions_export_history_status__PENDING: 'Queue',
  transactions_export_history_status__PROCESSING: 'Processing...',
  transactions_export_history_status__COMPLETE: 'Ready to download',
  transactions_export_history_status__ERROR: 'Export failed',
  transactions_export_history_type__PLEXUS: 'Plexus',
  transactions_export_history_type__PLEXUS_WITHOUT_TICKETS: 'Plexus without receipts',
  transactions_export_history_type__CUSTOM_WITHOUT_HISTORY: 'Custom file',
  transactions_export_history_type__CUSTOM: 'Custom file',
  transactions_export_history_type__CATEGORIES_BY_USER: 'Production by category',

  transactions_export_history_type__WRAP_FILE: 'WRAPFILE format',
  transactions_export_history_type__SMILE: 'Smile Format',

  transactions_export_history_type__ROSA_GRES: 'Accounting format',
  transactions_export_history_type__NORMAL_BUDGETS: 'Normal/{budget}',
  transactions_export_history_type__COMPLETE_BUDGETS: 'By users/{budget}',
  transactions_export_history_type__HOLDED_BUDGETS: 'Holded/{budget}',
  transactions_export_history_type__NAVISION_BUDGETS: 'Navision/{budget}',
  transactions_export_history_type__BUDGETS_BUDGETS: 'Budget/{budget}',

  transactions_export_history_type__CATEGORIES_BY_USER_BUDGETS: 'Production by category/{budget}',
  transactions_export_history_type__WRAP_FILE_BUDGETS: 'WRAPFILE format/{budget}',
  transactions_export_history_type__SMILE_BUDGETS: 'SMILE format/{budget}',

  /* - Edit Transaction Modal - */
  transactions_edit_original_amount: 'Original amount',
  transactions_edit_exchange_rate: 'Exchange rate',
  transactions_edit_transaction_modal_header: 'Transaction Details',
  transactions_edit_reimbursement_modal_header: 'Expense details',
  transactions_edit_diet_modal_header: 'Diet details',
  transactions_edit_mileage_modal_header: 'Mileage details',
  transactions_edit_transaction_required_fields: 'Required Fields',
  transactions_edit_transaction_optional_fields: 'Optional Fields',
  transactions_edit_transaction_notes_field: 'Notes',
  transaction_edit_receipt: 'Receipts',
  trasaction_detail_empty_receipt: 'Receipt to be associated',
  trasaction_detail_without_receipt: 'Without receipt',
  transaction_edit_bill_type: 'Invoice or receipt',
  transaction_edit_receipt_number: 'Receipt or invoice number',
  transaction_edit_receipt_available: 'Available Receipts',
  transactions_edit_transaction_save: 'Save changes',
  transactions_edit_no_resources: 'No Files Uploaded',
  transactions_edit_transaction_category: 'Category',
  transactions_edit_transaction_subcategory: 'Subcategory',
  transactions_edit_transaction_payment_method: 'Payment method',
  transactions_edit_transactions_custom_category: 'Subcategory',
  transactions_edit_transaction_amount: 'Amount',
  transactions_edit_transaction_date: 'Date',
  transactions_edit_transaction_merchant: 'Merchant',
  transactions_edit_transaction_budget: 'Budget',
  transaction_data: 'Transaction data',
  reimbursement_data: 'Expense data',
  mileage_data: 'Mileage data',
  diet_data: 'Diet data',
  transaction_tax_data: 'Tax data',
  transactions_edit_receipt_number: 'Receipt number',
  transactions_edit_company_name: 'Company name',
  transactions_edit_identity_number: 'CIF',
  transactions_edit_tax_region: 'Tax region',
  transactions_edit_taxes: 'Tax',
  transaction_edit_address_address: 'Address',
  transaction_edit_ocr_receipt: 'OCR (Receipt {index})',
  transactions_edit_transaction_resources_amount:
    '{resourcesAmount} file uploaded | {resourcesAmount} files uploaded',
  transaction_without_receipt_modal_title: 'I have no receipt',
  transaction_without_receipt_modal_message: 'You can edit the note or add a receipt if needed',
  transaction_without_receipt_edit_note: 'Edit note',
  categories_action_fetch_categories_error:
    'Whoops! Something went wrong while trying to fetch the categories',
  transactions_edit_cif_field: 'CIF',
  transactions_edit_social_reason_field: 'Business name',
  transactions_edit_tax_base: 'Tax Base',
  transactions_edit_quota: 'Quota',
  transactions_transaction_edit_lock_transaction: 'Lock transaction',
  transaction_dont_have_receipt: 'I do not have a receipt',
  transactions_transaction_edit_review_transaction: 'Mark as reviewed',
  transaction_edit_transaction_lock_warning:
    'You are about to lock this transaction. Once it is locked up, you will not be able to change its information. Do you wish to continue?',
  transaction_edit_transaction_lock_warning_incomplete_transaction:
    'The information of this transaction is incompleted and if you locked it up you will not be able to change its information. Do you wish to continue?',
  transaction_edit_locked_transaction_label: 'Locked the {date} by {user} ',
  transactions_lock_transaction_success: 'Transaction locked successfully',
  transactions_unlock_transaction_success: 'Transaction unlocked successfully',
  transactions_edit_transaction_success:
    'Transaction marked as reviewed successfully',
  transactions_unreview_transaction_success:
    'Transaction marked as unreviewed successfully',
  transactions_review_selected_users_success: 'Transactions marked as reviewed successfully',
  transactions_review_selected_users_error: 'Whoops! Something went wrong while trying to mark the transactions as reviewed',
  transactions_lock_transaction_error:
    'Whoops! Something went wrong while trying to lock the transaction',
  transactions_review_transaction_error:
    'Whoops! Something went wrong while trying to mark the transaction as reviewed',
  transaction_is_locked_message:
    'The transaction is locked and any further changes cannot be made',
  transactions_choose_receipt_type: 'Select if the file is a receipt or an bill',
  transactions_choose_receipt_type_disclaimer: 'The uploaded expenses through this method are not signed by Fuell and are not homologated. If you have received this document by digital means, they do not require certification if their content have not been modified and they have been provided by a reliable source. {clickHereSlot}',
  transactions_choose_receipt_type_disclaimer_click_here: 'More info here',

  transactions_receipt_type_RECEIPT: 'Receipt',
  transactions_receipt_type_BILL: 'Bill',
  transactions_receipt_type_change_RECEIPT: 'Mark as receipt',
  transactions_receipt_type_change_BILL: 'Mark as bill',
  transactions_receipt_processing: 'Reading',
  transactions_receipt_signed_date: 'Document signed on {signedCreatedAt}',

  transactions_processing_tooltip_label: "We are processing the information for this expense and its information can't be modified during the process, please come back and check later",

  transaction_review_tooltip_label: 'Reviewed by {0} {1} the {2}',
  transaction_accounted_tooltip_label: 'Accounted por {0} {1} el {2}',
  transaction_lock_tooltip_label: 'Blocked by {0} {1} the {2}',
  transaction_lock_accounting_period: 'Blocked by accounting period {0}',
  transactions_receipt_type_change_question: 'Are you sure you want to change the type of receipt?',
  transaction_dont_send_to_devoluiva:
    'Do not request bill with VAT for this transaction',
  transaction_upload_in_progress_title: 'Our OCR is up and running!',
  transaction_upload_in_progress_description: 'We are reading your receipt, you can safely exit out of the expense. We will fill in the data for you',
  transaction_upload_in_progress_understood: 'Understood',

  transaction_dont_send_to_devoluiva_error:
    'Whoops! Something went wrong while trying to update the transaction',
  transaction_is_locked_error: 'This transaction is locked',
  transaction_upload_receipt_invalid_mimetype:
    'Invalid receipt format, remember that you may upload images or PDF files',

  transaction_delete_transaction: 'Remove transaction',
  transaction_delete_expense: 'Remove expense',
  transaction_delete_mileage: 'Remove mileage',
  transaction_delete_diet: 'Remove diet',

  transactions_remove_transaction_success: 'Transaction removed successfully',
  transactions_remove_transaction_error:
    'Whoops! Something went wrong while trying to remove the transaction',
  /* - Transaction Receipt Modal - */
  transactions_receipt_modal_header: 'Transaction Receipts',
  expense_modal_information_label:
    'Have you made a corporative expense with your money? Add it here so that the company can refund you (if it fits the expense policy).',

  transactions_receipt_modal_body:
    'This are the resources bounded to this transaction',
  transactions_receipt_modal_body_zero_results:
    'There are no resources bounded to this transaction',
  /* ------ */
  /* - Transactions Snackbar Messages  - */
  transactions_fetch_transactions_error:
    'Whoops! Something went wrong while trying to fetch transactions',
  transactions_fetch_transaction_error:
    'Whoops! Something went wrong while trying to get the information of this transaction',

  transactions_put_transaction_resource_error:
    'Whoops! Something went wrong while trying to upload the receipt for this transaction',
  transaction_edit_transaccion_success: 'Transaction updated successfully',
  transaction_put_transaction_error:
    'Whoops! Something went wrong while trying to edit this transaction',
  transactions_export_transactions_error:
    'Whoops! Something went wrong while trying to export the transactions list',
  transactions_fetch_budget_custom_field_error: 'Whoops! Something went wrong while trying to get the custom fields for the budget',
  transaction_warning_AMOUNT_EXCEEDED: 'The amount of this expense is high',
  transaction_warning_DUPLICATE: 'Duplicate expenditure',
  transaction_warning_OUT_OF_ASSIGNED_TIME: 'Spending out of schedule',
  transaction_warning_WITHOUT_TICKET: 'Expenditure without receipt',
  transaction_warning_AMOUNT_DISTINCT_OCR: 'Our OCR has read a different amount on the receipt than the amount shown on the expense.',
  transaction_warning_DISTANCE_CUSTOM_WRONG: 'Distance modified by hand',
  transaction_warning_DISTANCE_MANUAL: 'Distance added by hand because it could not be calculated.',
  transaction_warning_AMOUNT_DISTINCT_SUM_TAXES: 'The indicated amounts does not match the total',
  transaction_warning_duplicate_text: 'Expense {index}',
  transaction_warning_duplicate_link: 'Go to expense',
  transaction_warning_duplicate_tooltip: 'We have detected that the expenses in the list have the same associated receipt. You can check it by following the link to each expense.',
  transaction_warning_ignore: 'Ignore',
  transaction_warning_ignore_modal: 'Ignore alert',
  transaction_warning_ignore_message: 'Are you sure to ignore the alert? This action cannot be undone',
  transaction_close_delete_draft: 'Save draft',
  transaction_close_delete: 'Delete expense',
  transaction_close_without_save: 'Exit without saving',
  transaction_close_without_save_description: 'Are you sure you want to close without saving the expense?',
  /* - Transactions filters */
  transactions_filter_transaction_status: 'Status',
  transactions_filter_is_bill_all: 'All',
  transactions_filter_transaction_tax_type: 'IVA',
  transactions_filter_tax_types_all: 'All',
  transactions_filter_is_bill_only_bills: 'Bills',
  transactions_filter_is_bill_only_receipts: 'Receipts',
  transactions_filter_transaction_accounting_period: 'Accounting period',
  transactions_filter_transaction_is_bill: 'Bills or receipts',
  transactions_filter_budgets_search: 'Type in to search budgets',
  transactions_filter_customer: 'Customers',
  transactions_filter_customer_search: 'Search customers',
  transactions_filter_user_search: 'Type in to search users',
  transactions_filter_transaction_review_status: 'Reviewed or not reviewed',
  transactions_review_status__ALL: 'All',
  transactions_review_status__REVIEWED: 'Reviewed',
  transactions_review_status__NOT_REVIEWED: 'Not reviewed',
  transactions_filter_transaction_personal_expense: 'Personal expense',
  transactions_review_status__PERSONAL_EXPENSE: 'Personal expense',
  transactions_filter_transaction_warning: 'Warnings',
  transactions_filter_transaction_account: 'Accounting',
  transactions_filter_transaction_account_ALL: 'All',
  transactions_filter_transaction_account_ACCOUNTED: 'Accounted for',
  transactions_filter_transaction_account_UNACCOUNTED: 'Not accounted',
  transaction_discounting: 'Disaccount',
  transaction_account: 'Account',
  transactions_warning__ALL: 'All',
  transactions_warning__WITH_WARNINGS: 'With warnings',
  transactions_review_status__NO_WARNINGS: 'No warnings',
  transactions_filter_review_status: 'Review status',
  transactions_filter_review_status_placeholder: 'Filter by review status',
  transactions_filter_review_status_placeholder_check_selected_filters: 'Check selected filters',
  transactions_filter_review_status_flow_header_reviewed: 'Reviewed',
  transactions_filter_review_status_flow_option_approved: 'Approved',
  transactions_filter_review_status_flow_option_rejected: 'Rejected',
  transactions_filter_review_status_flow_option_personal_expense: 'Personal expense',
  transactions_filter_review_status_flow_list_header_in_review: 'In review',
  transactions_filter_budgets_show_archived_option: 'Show archived budgets',
  transactions_filter_users_show_deleted_option: 'Show deleted users',
  transactions_filter_users_deleted_user: 'Deleted',

  /* ------ */

  /* -- REVIEW FUNNEL -- */
  transactions_funnel_actions_send_for_review: 'Request review',

  transactions_funnel_actions_reject: 'Reject',
  transactions_funnel_update_status_transition_not_allowed:
    "You can't move the review status to the one you are requesting",
  transactions_change_funnel_status_success: 'Status updated successfully',
  transactions_change_review_status_error:
    'Whoops! Something went wrong while trying to change the review status',
  transactions_funnel_reject_reason_modal_title: 'Add a note',
  transactions_funnel_reject_reason_modal_message:
    'Add a note to explain why the expense has been rejected',
  transactions_funnel_reject_reason_modal_placeholder: 'Add a note',
  transactions_funnel_reject_reason_modal_validation_error: 'In order to reject the expense you must indicate an explanation note',
  transactions_funnel_reject_reason_close_modal_title: 'Close modal',
  transactions_funnel_reject_reason_close_modal_warning: 'If you close this window you will not reject this expense. Are you sure about closing the window?',
  transactions_funnel_reject_reason_close_modal_warning_confirm_close: 'Close',
  transactions_funnel_reject_reason_close_modal_warning_add_note: 'Add a note',

  transaction_funnel_reject_reason: 'Reject reason',
  transaction_expense_rejected_label: 'Rejection reason: {reviewRejectReason}',
  transactions_funnel_reject_reason_add_note_modal_title: 'Add a note',
  transactions_funnel_reject_reason_add_note_modal_message: 'Add the note you want the reviewers to read.',
  transactions_funnel_reject_reason_add_note_close_modal_warning: ' If you close this window, the {actionName} action will not be completed. Are you sure you want to close the window? ',
  transaction_funnel_comment_action_modal_action_approve: 'approve with note',
  transaction_funnel_comment_action_modal_action_mark_as_personal: 'mark as personal with note',
  transaction_funnel_comment_action_modal_action_reject: 'reject expense',

  transactions_not_receipt_reason_modal_message: 'Add a note to explain why why the receipt is missing',
  transactions_not_receipt_reason_modal_placeholder: 'Reason for non-receipt',
  transactions_review_status__DRAFT: 'Draft',
  transactions_review_status__AWAITING_REVIEW: 'Awaiting review',
  transactions_review_status__APPROVED: 'Approved',
  transactions_review_status__CANCELLED: 'Rejected',
  transactions_review_status__CREATED: 'Expense created',
  transactions_review_status__OFFICE_FLOW_REVISION: 'In review',
  transactions_review_status__NOT_VALID: 'Not validated',
  transactions_review_status__VALID: 'Validated',
  transactions_status_processing: 'Retained expense',
  transactions_detail_review_log_header: 'History',
  transactions_review_status_log_check_history: 'Check history',
  transactions_review_status_log_sent_for_review: 'Sent for review',
  transactions_review_status_log_reviewed: 'Reviewed',
  transactions_funnel_actions_review: 'Review',
  transactions_funnel_actions_unreview: 'Unreview',
  transactions_funnel_actions_approve: 'Approve',
  transactions_funnel_actions_approve_with_comments: 'Approve with note',

  transactions_funnel_actions_unmark_as_personal: 'Unmark as personal expense',
  transactions_funnel_actions_mark_as_personal: 'Personal expense',
  transactions_funnel_actions_mark_as_personal_with_comments: 'Personal expense with note',
  transactions_funnel_actions_apply_changes: 'Apply',
  transactions_funnel_actions_undo: 'Undo',
  transactions_status_personal_expense: 'Personal expense',
  transaction_taxes_error: 'The amounts indicated do not match the amount of expense.',
  /* --- */

  /* - My Expenses  */
  transactions_my_expenses_reimbursements: 'My expenses',
  transactions_my_expenses_transactions: 'My transactions',
  /* --- */
  /* -- Multiple transactions keys */
  transactions_review_selected_transactions_success:
    'Transactions have been marked as reviewed successfully',
  transactions_review_selected_transactions_error:
    'Whoops! Something went wrong while trying to mark the transactions as reviewed',
  transactions_unreview_selected_transactions_success:
    'Transactions have been marked as not reviewed successfully',
  transactions_unreview_selected_transactions_error:
    'Whoops! Something went wrong while trying yo mark the transactions as not reviewed',
  transactions_account_selected_transactions_success: 'Account',
  transactions_account_selected_transactions_error: 'Transactions have been marked as successfully accounted for',
  transactions_mark_as_review: 'Mark as reviewed',
  transactions_mark_as_unreviewed: 'Mark as not reviewed',
  transactions_confirm_mark_selected_transactions_as_reviewed:
    'Mark transactions as reviewed',
  transactions_confirm_mark_selected_transactions_as_unreviewed:
    'Mark transactions as not reviewed',
  transactions_multiple_transactions_selected_to_review:
    'You have selected {transactionsAmount} transaction(s) to mark as reviewed, press Yes to continue and No to return',
  transactions_multiple_transactions_selected_to_unreview:
    'You have selected {transactionsAmount} transaction(s) to mark as not reviewed, press Yes to continue, and No to return',
  transactions_multiple_transactions_action_confirm:
    'You are going to modify {transactionsTotalItems} transactions. Continue?',
  transactions_total_transactions_bulk_selection:
    'You have selected the {selectedTransactions} loaded transaction(s) out of {transactionsTotalItems} total. ',
  transactions_total_transactions_bulk_selection_all:
    'You have selected all {transactionsTotalItems} existing transactions. ',
  transactions_total_transactions_bulk_selection_action_select: 'Select all {transactionsTotalItems} existing transactions',
  transactions_total_transactions_bulk_selection_action_cancel_select:
    'Undo selection',
  transactions_multiple_users_action_title: 'Approve expenses',
  transactions_multiple_users_action_confirm: 'Are you sure to approve these expenses?',
  transactions_bulk_action_warning_errors:
    'The action has been performed with some errors, we have loaded the ones that have failed',
  transactions_bulk_action_no_context_error:
    'Transactions have been processed, but some of then have not been modified because they are either blocked or not in the proper review status for the requested action',
  transactions_bulk_action_invalid_budget_goal_error:
    'Some expenses surpass the goal of the following budgets :',
  transactions_bulk_action_warning_confirm: 'You have selected {selectedTransactionsCount} expenses of which only {validAmount}  can be {bulkAction}. Continue?',
  transactions_bulk_action_name__APPROVE: 'Review',
  transactions_bulk_action_name__REJECT: 'Reject',
  transactions_bulk_action_name__LOCK: 'Lock',
  transactions_bulk_action_name__UNLOCK: 'Unlock',
  transactions_bulk_action_name__UNREVIEW: 'Unreview',
  transactions_bulk_action_name__ACCOUNT: 'Account',

  /*  Transactions --- Accounting periods */
  accounting_close_accounting_periods: 'Close accounting period',
  accounting_select_accounting_period_placeholder: 'Select accounting periodo',
  accounting_periods_action_close_periods: 'Close period',
  accounting_periods_closure_transaction_closure_warning:
    "Once closed, all transactions will be blocked and couldn't be modified.",
  accounting_periods_closure_transaction_closure_undo_warning:
    " This action can't be undone.",
  accounting_period_closure_warning:
    'Transactions will be blocked, ¿Do you want to continue?',
  accounting_period_closure_transactions_affected:
    'There are {amount} transactions {action} without all information',
  accounting_period_action_click: '(click to check)',
  accounting_closure_in_progress: 'Closing period...',
  accounting_periods_closure_success:
    'Accounting perids has been closed sucessfully',
  accounting_periods_closure_error:
    "Whoops! We've found a problem closing the accounting period:",

  /* - Transactions Misc - */
  transactions_row_file_amount: '{count} file | {count} files',
  /* -- */

  /* - Accounting - */
  accounting_action_fetch_accounting_periods_error:
    'Whoops! Something went wrong while trying to fetch accounting periods',

  /* -  Expenses - */
  expenses_save_as_draft: 'Save as draft',
  expenses_send_to_review: 'Send for review',
  expenses_send_to_review_description: 'In order to be able to submit the expense for review, a receipt needs to be added',
  expenses_upload_receipt: 'Upload receipt',
  expenses_expense_is_reimbursable: 'Refundable',
  expenses_expense_is_not_reimbursable: 'Not refundable',

  /* - Create Expense Modal - */
  expenses_create_expense_header: 'Add expense',
  expenses_create_reimbursement_header: 'Add expense',
  expenses_edit_reimbursement_header: 'Expense detail',
  expenses_edit_expense_header: 'Expense details',
  expense_merchant_name: 'Merchant',
  expense_payment_method: 'Payment method',
  expense_amount: 'Amount',
  expense_exchange_rate: 'Exchange rate',
  expense_default_currency_amount: 'Amount in euro',
  expense_edit_expense_date: 'Date',
  expense_budget: 'Budget',
  expense_notes: 'Notes',
  expense_budget_not_enough_funds: '- Not enough funds',
  expenses_mark_as_refund: 'Refund',

  expense_create_expense_success: 'Expense added successfully',
  expense_create_expense_error:
    'Whoops! Something went wrong while trying to add the expense',
  expense_edit_expense_error:
    'Whoops! Something went wrong while trying to edit the expense',

  /* - Create Mileage Modal - */
  expense_create_mileage_header: 'Create mileage expense',
  expense_edit_mileage_header: 'Edit mileage expense',
  expense_mileage_origin: 'Origin',
  expense_mileage_destination: 'Destination',
  expense_mileage_category: 'Category',
  expense_mileage_distance_kms: 'Distance (in Kms)',
  expense_mileage_distance: 'Distance',
  expense_mileage_distance_calculated: 'Calculated distance: {kms}km',
  expense_mileage_distance_round_trip: 'Distance (round trip)',
  expense_mileage_amount_abbr: 'Amo.',
  expense_mileage_amount: 'Amount',
  expenses_create_mileage_no_categories_found_admin: 'There are no mileage categories, {link} to create them',
  expense_create_mileage_no_categories_found: 'There are no mileage categories, ask your administrator to create them to continue',
  expense_create_mileage_categories_no_options: 'There are no mileage categories',
  expense_create_mileage_categories_no_results: 'No categories where found',

  expense_create_mileage_round_trip_check: 'Roundtrip',
  expenses_create_mileage_success: 'Mileage created successfully',
  expense_create_mileage_error:
    'Whoops! Something went wrong while trying to create the mileage',
  expense_create_mileage_map_default:
    'Introduce and select origin and destination to show the map and calculate the distance between both locations',
  expense_create_mileage_map_route_error_manual:
    'There was an error calculating the route.',
  expense_create_mileage_map_route_error:
    'There has been an error calculating the route. You can enter the distance manually.',
  /* - Create Diet Modal  - */
  expenses_create_diet_header: 'Create diet',
  expenses_edit_diet_header: 'Edit diet',
  expenses_create_diet_label_origin: 'Origin',
  expenses_create_diet_label_to: 'To',
  expenses_create_diet_label_destination: 'Destination',
  expenses_create_diet_categories_to_apply: 'Select number and type of diet to apply',
  expense_create_diet_category_select_diet_category_placeholder: 'Add diets',

  expenses_create_diet_no_categories_found_admin:
    " You haven't defined diet categories yet, {link} to define them",
  expenses_create_diet_no_categories_found:
    "There aren't any diet categories defined yet, please ask your administrator to create them",
  expenses_create_diet_success: 'Diet created successfully',
  expense_create_diet_error:
    'Whoops! Something went wrong while trying to create the diet',
  expenses_edit_diet_success: 'Diet edited successfully',
  expenses_edit_diet_error:
    'Whoops! Something went wrong while trying to edit the diet',
  expense_create_diet_define_waypoints:
    'Type and select origin and destination to show the route',
  expense_diet_amount_summary: 'The amount of this diet is: {totalAmount}',
  expense_diet_add_destination: '+ Add destination',

  /* ------------------------------------------------------- */

  /* -- BUDGETS TERMS -- */

  budgets_action_fetch_budgets_error:
    'Whoops! Something went wrong while trying to fetch budgets',
  budgets_tabs_active_budgets: 'Active',
  budgets_tabs_archived_budgets: 'Archived',
  budget_detail_expense_evolution_tab: 'Expense evolution',

  budget_detail_reimbursements_tab: 'Expenses',

  budgets_new_budget: 'New Budget',
  budgets_add_members: 'Add Members',
  budgets_budget_owner: 'Owner',
  budgets_budget_member: 'Member',
  budgets_budget_type__PUNCTUAL: 'One Time',
  budgets_budget_type__MONTHLY: 'Monthly',
  budgets_budget_type__DAILY: 'Daily',
  budgets_budget_type__WEEKLY: 'Weekly',

  budgets_budget_status__ARCHIVED: 'Archived',
  budgets_budget_status__ACTIVE: 'Active',
  budgets_budget_days_to_expiration: '{daysToExpire} days to expire',
  budgets_budget_day_expires_today: 'Expires today',
  budgets_budget_days_to_expiration_expired: 'Expired Budget',
  budgets_budget_goal_limit: 'Budget Limit',
  budgets_budget_assigned: 'Assigned',
  budgets_budget_spent: 'Spent',
  budget_detail_header_limit: 'Limit:',
  budget_detail_header_assigned: 'Assigned:',
  budget_detail_header_spent: 'Spent:',
  budget_confirm_archive_budget_header_action: 'Archive budget',
  budget_confirm_archive_budget_text:
    'You are about to archive the budget {budgetName}, this action is irreversible, to continue, press Archive budget, otherwise, press Cancel',
  /* -- New budgets -- */
  budgets_new_budget_header: 'Budget details',
  budgets_new_budget_budget_name: 'Budget Name',
  budgets_new_budget_budget_limit: 'Limit',
  budgets_new_budget_type_monthly: 'Monthly',
  budgets_new_budget_type_one_time: 'One time',
  budgets_budget_type__PUNCTUAL_info:
    'Set a goal and spend until it runs out. Goal does not reset.',
  budgets_budget_type__DAILY_info:
    'Set a daily recurring goal. Goal resets at 00:00 of the following day',
  budgets_budget_type__WEEKLY_info:
    'Set a weekly recurring goal. Goal resets at 00:00 of the beggining of the following week',
  budgets_budget_type__MONTHLY_info:
    'Set a recurring goal every month. Goal resets each day 1st of the month.',

  budgets_new_budget_expiration: 'Expiration',
  budgets_new_budget_owners: 'Owners (at least one)',
  budgets_new_budget_members: 'Members',
  budgets_new_budget_review_flow: 'Review flow',
  budgets_new_budget_review_flow_default_flow_info: 'This is the review flow used in Fuell when you do not want to use a multilevel review flow. It has one review step for budget owners, admins and bookkeepers.',
  budgets_new_budget_fuell_default_review_flow: 'Simple review',
  budgets_new_budget_default_review_flow: '(by default)',

  budget_action_create_budget_success: 'Budget created successfully',
  budgets_action_create_budget_error:
    'Whoops! Something went wrong while trying to create this budget',
  /* ---- */
  /* - Budget Detail Members - */
  budget_detail_members_tab: 'Budget Members',
  budget_detail_members: 'Member',
  budget_detail_budget_assigned: 'Assigned',
  budget_detail_budget_spent: 'Spent',
  budget_detail_budget_available: 'Available',
  budget_detail_budgter_spent_vs_available: '% Spent vs Available',
  budget_user_member_owner: 'Owner',
  budget_detail_user_not_assigned: 'This user is not assigned to any budget.',
  budget_detail_assign_user: 'Assign a budget to this user',
  budgets_action_update_user_assigned_budget_success:
    'User assignation has been updated successfully',
  budgets_action_update_user_budget_success:
    'Budget user information has been updated successfully',
  budgets_action_update_user_assigned_budget_error:
    'Whoops! Something went wrong while trying to update the assignation from this user',
  budgets_update_user_assign_error: 'You have to input an amount',
  budgets_update_user_assign_greater_than_goal_error:
    "You can't assign an ammount greater than this budget's limit goal",
  budgets_update_user_assign_lower_than_spent_error:
    "You can't assign an amount lower than the spent",

  budget_detail_budget_spent_tooltip: 'Spent: {spent}',
  budget_detail_budget_available_tooltip: 'Available: {available}',
  budget_assignation_increase_alert: 'This users assigned amount has been increased in  {reimbursementSpent} with a total assigned of {totalAssigned} temporarily as this user has expenses that has been approved',

  /* - Budget Detail Transactions - */
  budget_detail_transactions_tab: 'Transactions',
  /* - Budget Settings - */
  budget_month_goal_edit_warning:
    'This is the budget goal for the current month. Changes will not affect future months.',
  budget_action_archive_budget_success:
    'This budget has been archived successfully',
  budgets_action_archive_budget_error:
    'Whoops! Something went wrong while trying to archive this budget',
  budgets_update_budget_success: 'Budget updated successfully',
  budgets_update_budget_error:
    'Whoops! Something went wrong while trying to update this budget',
  /* --------------------------------------- */

  /* --------------------------------------- */

  /* CARD FROZEN */
  card_frozen_modal_title: 'Freeze card',
  card_frozen_modal_description: 'If you freeze the card only a user with administrator role will be able to unfreeze it. Are you sure?',
  card_frozen_modal_frozen: 'Freeze',

  /* ---- */
  /* -- CARDS TERMS -- */
  card_status__DISABLED: 'Disabled',
  card_status__ACTIVE: 'Active',
  card_status__FROZEN: 'Frozen',
  card_status__FROZEN_tooltip: 'Frozen by user',
  card_status__FROZEN_BY_ADMIN: 'Frozen by admin',
  card_status__BLOCKED: 'Blocked',
  card_status__PENDING: 'Pending',
  card_status__CANCELLED: 'Cancelled',
  card_not_generated: 'Card still not issued',
  card_mp_identifier: 'MP Number',
  cards_budget_cards_explanation:
    'For online purchases and subscriptions. Funds pull directly from the budget they are assigned to.',
  cards_physical_cards_explanation:
    'For in-store purchases. Funds pull directly from what has been assigned to the user.',
  cards_virtual_cards_explanation:
    'For online purchases and subscriptions. Funds pull directly from what has been assigned to the user.',
  cards_virtual_cards_creation_explanation:
    'To add a virtual card you may use our smartphone app',
  cards_action_new_card: 'New Card',
  card_status_action_freeze_by_admin_card: 'Frozen card',
  card_status_action_unfreeze_card: 'Unfreeze card',
  card_status_action_freeze_card: 'Freeze card',
  card_action_passcode_not_found: 'Passcode needed',
  card_passcode_request_instructions:
    'For security reasons we need you to configure a Passcode in your profile in order to work with your cards',
  action_go_to_profile: 'Go to my profile',

  cards_detail_budget: 'Budget',

  card_detail_modal_overview: 'Overview',
  card_detail_modal_transactions: 'Transactions',
  /* ------------------- */
  /* --- Logs Section ---- */
  logs_office_log_tab: 'Customer Logs',
  logs_user_log_tab: 'User Logs',
  logs_cards_log_tab: 'Card Logs',
  logs_webhook_log_tab: 'WebHook Logs',
  fetch_log_error: 'Something went wrong while trying to fetch logs: ',

  /* ------------------ */
  /* - COMPANY TERMS  --- */
  company_settings_company_details_tab: 'Company details',
  company_settings_transaction_fields_tab: 'Expenses settings',
  company_settings_expense_fields_tab: 'Mileage and diets',
  company_settings_integrations: 'Integrations',
  company_settings_export: 'Export settings',

  /* - Company Details - */
  company_details_company_name: 'Company name',
  company_details_company_address: 'Company address',
  company_details_company_zip_code: 'Zip code',
  company_details_company_city: 'City',
  company_details_company_country_state: 'Country / State',
  company_details_company_registration_number: 'Company registration number',
  company_details_company_change_information_message:
    'Do you want to change or update something?  {0}',
  company_support_update_company_information_message:
    'Hello, I would like to change my company information. What should I do?',
  company_details_transaction_fields_subtitle:
    'Edit and create the fields shown in expenses and transactions',
  company_details_default_fields_title: 'Fields and alerts settings',
  company_details_receipt_settings: 'Receipt settings',
  company_details_receipt_settings_description:
    'Set the options for the receipts',
  company_details_categories_and_subcategories: 'Categories and subcategories',
  company_details_categories_and_subcategories_description:
    'Create custom sub-categories',
  company_details_fields_settings_required_fields: 'Required fields',
  company_details_fields_settings_required_fields_description: 'Define the expenses required fields',

  company_details_fields_settings_alerts: 'Alerts',
  company_details_fields_settings_alerts_description: 'Set alerts for duplicated expenses or expenses out of time',

  company_details_fields_settings_payment_methods: 'Payment methods',
  company_details_fields_settings_payment_methods_description: "Define you company's accepted payment methods",
  company_details_fields_settings_cards_schedule: 'Fuell card usage schedule',
  company_details_fields_settings_company_details_fields_settings_cards_schedule_description: 'Defines the hours when payments can be made with the Fuell card',
  company_details_add_fields: 'Add fields',
  company_details_new_field_button: 'New field',
  company_details_new_category_button: 'Create category',

  company_details_new_subcategory_button: 'Add subcategory',
  company_details_remove_subcategory_action: 'Remove subcategory',

  company_details_action_create_custom_category_success:
    'Subcategory has been created successfully',
  company_details_action_create_custom_category_error:
    'An error has been occurred creating the subcategory',
  company_details_action_update_custom_category_success:
    'Subcategory has been updated successfully',
  company_details_action_update_custom_category_error:
    'An error has been occurred updating the subcategory',
  company_details_action_delete_custom_category_success:
    'Subcategory has been deleted successfully',
  company_details_action_delete_custom_category_error:
    'An error has been occurred deleting the subcategory',
  company_details_action_update_default_category_success:
    'Category has been updated successfully',
  company_details_action_update_default_category_error:
    'An error has been occurred updating the category',
  company_details_category_field: 'Category',
  company_details_subcategory_name_field: 'Subcategory name',
  company_details_account_number_field: 'Code',
  company_details_tax_field: 'VAT',
  company_details_confirm_modal_delete_subcategory:
    "You're going to delete the {name} subcategory. This action can't be undone.",

  company_details_create_category_category_name: 'Category name',
  company_details_create_category_category_color: 'Color',

  company_details_create_category_create_category_action: 'Create category',
  company_details_new_category_title: 'Create category',
  company_details_edit_category_title: 'Edit category',
  company_details_edit_category_action: 'Save changes',
  company_details_delete_category_title: 'Remove category',
  company_details_dete_category_info: 'Are you sure you want to delete the category? All the associated subcategories will be deleted as well. This action can not be undone',
  company_details_new_category_action_success: 'The category has been created successfully',
  company_details_new_category_action_error: 'Whoops! Something went wrong while creating the category',

  company_details_admin_notifications_header: 'Management notifications',
  company_details_admin_notifications_copy:
    'Indicate the email address you want to notify when your account is running out of balance, the available balance is lower than the assigned funds or when a top up greater than 1.000€ is performed',
  company_details_notification_mails_list: 'Emails to notify',
  company_details_notification_mails_placeholder:
    'Type to add or select an email...',
  company_details_notification_mails_add_tag_placeholder: 'Add email',
  company_details_notification_mails_selected_label:
    'Already on list,click to remove',
  company_details_notification_mails_invalid_mail: 'Introduce a valid email',
  company_details_notification_mail_submit_error:
    'Whoops! Something went wrong while trying to update the mail to notify list',
  company_details_company_time_zone: 'Time zone',

  /* - Company Fields  */

  company_transaction_fields_table_transaction_field_name_header:
    'Transaction field',
  company_transaction_fields_table_field_options_header: 'Field options',
  company_transaction_fields_table_budgets_header: 'Budgets',
  company_transaction_fields_table_include_in_transaction_type_header: 'Included in',

  /* Mandatory Fields Modal */
  company_required_fields_modal_header: 'Required fields',
  company_required_fields_modal_info: 'Define the fields the employees must fill in.',

  company_required_fields_modal_form__MILEAGE: 'Mileages',
  company_required_fields_modal_form__DIET: 'Diets',
  company_required_fields_modal_form__REIMBURSEMENT: 'Expenses',
  company_required_fields_modal_form__EXPENSE: 'Expenses',
  company_required_fields_modal_form__TRANSACTION: 'Transactions',
  company_required_fields_modal_form_field__paymentMethod: 'Payment methods',
  company_required_fields_modal_form_field__dietSteps: 'Origin and destiny',
  company_required_fields_modal_form_field__dietCategoryConfigs: 'Diet category',
  company_required_fields_modal_form_field__medias: 'Receipts',
  company_required_fields_modal_form_field__budget: 'Budget',
  company_required_fields_modal_form_field__notes: 'Notes',
  company_required_fields_modal_form_field__amount: 'Amount',
  company_required_fields_modal_form_field__mileageCategory: 'Mileage category',
  company_required_fields_modal_form_field__origin: 'Origin',
  company_required_fields_modal_form_field__destination: 'Destination',
  company_required_fields_modal_form_field__distance: 'Distance',
  company_required_fields_modal_form_field__roundTrip: 'Roundtrip',
  company_required_fields_modal_form_field__date: 'Date',
  company_required_fields_modal_form_field__isBill: 'Bill or receipt',
  company_required_fields_modal_form_field__provider: 'Merchant',
  company_required_fields_modal_form_field__transaction_provider: 'Social reason',
  company_required_fields_modal_form_field__defaultCategory: 'Category',
  company_required_fields_modal_form_field__providerData: 'CIF',
  company_required_fields_modal_form_field__receiptNumber: 'Receipt number',
  company_required_fields_modal_form_field__vatTypeAssigned: 'Taxation region',
  company_required_fields_modal_form_field__country: 'Country',
  company_required_fields_modal_form_field__state: 'State',
  company_required_fields_modal_form_field__zipCode: 'Zip code',
  company_required_fields_modal_form_field__city: 'City',
  company_required_fields_modal_form_field__address: 'Address',
  company_required_fields_modal_form_field__taxes: 'Taxes',

  company_required_fields_modal_option_field_name: 'Field name',
  company_required_fields_modal_option_field_required_status: 'Required',
  company_required_fields_modal_update_setting_success: 'Setting updated successfully',
  company_required_fields_modal_update_setting_error: 'Whoops! Something went wrong while trying to update the requested setting',

  /* Create Custom Field Modal */
  company_create_transaction_field_modal_header: 'Create new field',
  company_update_transaction_field_modal_header: 'Update field',
  company_update_transactions_transactions_affected_warning:
    'You have transactions affected by this custom field, do you want to continue?',

  company_create_transaction_field_name: 'Name',
  company_create_transaction_field_name_placeholder: 'Enter field name',
  company_create_transaction_field_description: 'Description',
  company_create_transaction_field_description_placeholder:
    'Enter description for the field',
  company_create_transaction_field_option_type: 'Option Type',
  company_create_transaction_field_allow_multiselect:
    'Allow multi-select options',
  company_create_transaction_field_option_settings: 'Option Settings',
  company_create_transaction_field_option_settings_placeholder:
    'Add field options',
  company_create_transaction_field_option_tag_transaction_detail_placeholder:
    'Create option',

  company_create_transaction_field_allow_custom_options: 'Allow custom options',
  company_create_transaction_field_allow_custom_options_info:
    'Allow employees to create new options',
  company_create_transaction_field_budgets_include_in: 'Include in',
  company_create_transaction_field_include_in_all_budgets: 'All budgetw',
  company_create_transaction_field_include_in_all_budgets_explanation:
    'Include in all current and future budgets',
  company_create_transaction_field_include_in_selected_budgets:
    'Selected budgets',
  company_create_transaction_field_require: 'Require',
  company_create_transaction_field_require_never: 'Never',
  company_create_transaction_field_require_always: 'Always',
  company_create_transaction_field_require_selected_budgets:
    'For selected budgets',
  company_create_transaction_field_action_create_field: 'Create field',
  company_create_transaction_field_action_update_field: 'Update field',
  company_create_transaction_field_options_no_options:
    'Enter the option name and press enter ',
  company_create_transaction_field_select_budget: 'Select budget',
  company_create_transaction_field_no_budgets: 'There are no budgets',

  company_create_custom_field_success: 'The custom field has been created successfully',
  company_update_custom_field_success: 'The custom field has been udpated successfully',
  company_delete_custom_field_success: 'The custom field has been deleted successfully',

  company_create_custom_field_error:
    'An error occurred creating the custom field',
  company_update_custom_field_error:
    'An error occurred updating the custom field',
  company_delete_custom_field_error:
    'An error occurred deleting the custom field',
  company_fetch_transaction_fields_error:
    'An error occurred loading custom fields',
  company_fetch_company_error: 'An error occurred loading company details',
  company_update_company_information_error: "Whoops! Something went wrong while trying to update this company's information",
  company_update_company_information_success:
    'Company information updated successfully',
  company_create_custom_field_include_in_transaction_type: 'Include this field in',
  company_update_company_address_info: 'You are about to edit the card sending address for the company {customerName}, fill all the requested fields and press Send',
  company_update_company_address_warning: 'You are about to edit the card sending address for the company {customerName}, please be sure to check the data is correct and press Confirm to save the changes, otherwise press Cancel to return',
  company_update_company_fiscal_address_info: 'You are about to edit the billing address for the company {customerName},  fill all the requested fields and press Send',
  company_update_company_fiscal_address_warning: 'You are about to edit the billing address for the company {customerName}, please be sure to check the data is corrrect and press Confirm to save the changes, otherwise press Cancel to return',
  customer_edit_address_modal_header: 'Edit company card sending address',
  customer_edit_address_confirm: 'Edit address',

  customer_edit_fiscal_address_modal_header: 'Edit company billing address',
  customer_show_edit_fiscal_address_modal_action: 'Billing address of the company',
  customer_show_edit_address_modal_action: 'Card address',
  /* - Payment Methods modal - */
  company_payment_methods_settings_modal_title: 'Payment methods',
  company_payment_methods_settings_description: 'You may set up the payment methods admitted by your company besides your Fuell card. You may define the expense types in which the payment method may be used, employees allowed to use it, and if the payment methods allows  the reimbursement of the expense.',
  company_payment_methods_table_payment_method_header: 'Payment method',
  company_payment_methods_table_expense_type_header: 'Expense type',
  company_payment_methods_table_users_header: 'Users',
  company_payment_methods_table_repayable_header: 'Reimbursable',
  company_payment_methods_table_bydefault_header: 'By default',
  company_payment_methods_table_repayable_tooltip: 'Expenses marked with this option will appear as reimbursable in the export file',
  company_payment_methods_table_byDefault_tooltip: 'The payment methods you select will be assigned to new users by default',
  company_payment_methods_table_byDefault_disabled_tooltip: 'If the payment method is applied to All, it will be assigned by default to new users',
  company_payment_methods_table_payment_method_name_placeholder: 'Name',
  company_payment_methods_table_expense_type_placeholder: 'Expense type',
  company_payment_methods_table_users_placeholder: 'Users',
  company_payment_methods_add_payment_method_action: '+ Add payment method',
  company_payment_methods_modal_confirm_delete: 'Remove payment method',
  company_payment_methods_modal_confirm_delete_warning: 'Are you sure you want to delete this payment method? This action cannot be undone',
  company_payment_methods_modal_update_error: 'Whoops! Something went wrong while trying to update the payment method',
  company_payment_methods_modal_create_error: 'Whoops! Something went wrong while trying to create the payment method',
  company_payment_methods_modal_delete_error: 'Whoops! Something went wrong while trying to remove the payment method',
  company_payment_methods_modal_get_payment_methods_error: 'Whoops! Something went wrong while trying to get the payment methods',

  /* - Card Schedule Modal - */
  company_cards_schedule_settings_modal_title: 'Define card usage schedules',
  company_cards_schedule_settings_description: 'You can set up a timetable for the use of the cards according to the budget assigned to them. If a budget does not have an assigned schedule, the cards will be able to spend any day at any time.',
  company_cards_schedule_table_name_header: 'Name',
  company_cards_schedule_table_days_header: 'Days',
  company_cards_schedule_table_hours_header: 'Hours',
  company_cards_schedule_table_budgets_header: 'Budgets',
  company_cards_schedule_table_card_schedule_name_placeholder: 'Name',
  company_cards_schedule_table_budgets_placeholder: 'Budgets',
  company_cards_schedule_add_card_schedule_action: '+ Add timetable',
  company_cards_schedule_settings_default_title: 'Default timetable for new budgets',
  company_cards_schedule_settings_default_description: 'You can choose a timetable to be applied automatically to new budgets created in the company.',
  company_cards_schedule_settings_default_label: 'Default timetable',
  company_cards_schedule_modal_overwrite_budget: 'Change of assigned timetable',
  company_cards_schedule_modal_overwrite_budget_single: 'The budget you have selected has another timetable assigned to it. Do you want to assign this new timetable to it?',
  company_cards_schedule_modal_overwrite_budget_multiple: 'Several budgets you have selected have another timetable assigned to them. Do you want to assign them this new timetable?',
  company_cards_schedule_modal_confirm_delete: 'Delete card schedule',
  company_cards_schedule_modal_confirm_delete_warning: 'Are you sure you want to delete the timetable? This action cannot be undone',

  /* - Expenses Fields  - */

  expense_fields_creation_subtitle:
    'In this section you can configure aspects related to the expenses creation such as mileage categories.',
  expense_fields_mileage_categories: 'Mileage categories',

  company_expense_fields_mileage_category_header: 'Name',
  company_expense_fields_mileage_category_rate: 'Cost per kilometre',

  expense_fields_new_mileage_category: 'Add mileage category',

  /* - Create mileage modal - */
  company_create_mileage_category_modal_header: 'Create mileage category',
  company_edit_mileage_category_modal_header: 'Edit mileage category',
  company_create_mileage_category_modal_confirm: 'Create',
  company_edit_mileage_category_modal_confirm: 'Save changes',
  company_create_mileage_category_name: 'Name',
  company_create_mileage_category_rate: 'Cost per kilometre (€ / Km)',

  company_edit_diet_category_modal_header: 'Edit diet category',
  company_create_diet_category_modal_header: 'Create diet category',
  company_edit_diet_category_modal_confirm: 'Save changes',
  company_create_diet_category_modal_confirm: 'Create category',
  expense_fields_new_diet_category: 'Create diet category',
  company_update_diet_category_success: 'Diet category updated successfully',
  company_update_diet_category_error:
    'Whoops! Something went wrong while trying to update this diet category',
  company_create_diet_category_success: 'Diet category created successfully',
  company_create_diet_category_error:
    'Whoops! Something went wrong while trying to create the diet category',
  company_delete_diet_category_success: 'Diet category removed successfully',
  company_delete_diet_category_error:
    'Whoops! Something went wrong while trying to remove the diet category',
  expense_fetch_diet_categories_error:
    'Whoops! Something went wrong while trying to get the diet categories list',

  /* - Funnel Aproval options */

  company_funnel_aproval_flow_section_header: 'Aproval flow',
  company_funnel_aproval_flow_create_flow: 'Create aproval flow',
  company_funnel_aproval_flow_info: 'Create or edit review flows with different levels of review complexity.Budgets without a review flow will continue to work with our basic review system.',

  company_funnel_aproval_flow_table_column_name: 'Name',
  company_funnel_aproval_flow_table_column_aproval_levels: 'Aproval levels',
  company_funnel_aproval_flow_table_column_budgets: 'Budgets',
  /* Create funnel flow modal */
  company_create_funnel_flow_modal_header: 'Create multilevel aproval flow',
  company_edit_funnel_flow_modal_header: 'Edit multilevel aproval flow',

  company_create_funnel_flow_modal_form_name: 'Name',
  company_create_funnel_flow_modal_form_name_placeholder: 'Aproval flow name',
  company_create_funnel_flow_modal_form_include_flow_in: 'Include this aproval flow in',
  company_create_funnel_flow_modal_form_include_flow_in_all_budgets_option: 'All budgets {all_budgets_hint}',
  company_create_funnel_flow_modal_form_include_flow_in_all_budgets_option_hint: '(It will be included in current and new budgets)',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option: 'Selected budgets',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name: 'Budgets',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name_placeholder: 'Search...',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_all_budgets_option: 'All',
  company_create_funnel_flow_modal_form_mark_as_default_label: 'Use as default review flow',
  company_create_funnel_flow_modal_form_mark_as_default_info_tooltip: 'This review flow will be assigned by default to all new budgets created on the platform.',

  company_create_funnel_flow_modal_form_confirm_budget_change_header: 'Reassign review flow',
  company_create_funnel_flow_modal_form_confirm_budget_change_warning: 'This budget has another review flow assigned. Do you want to reassign this budget to this review flow?',
  company_create_funnel_flow_modal_form_confirm_budget_change_action_confirm: 'Reassign',

  company_create_funnel_flow_modal_form_confirm_default_flow_change_header: 'Review flow by default',
  company_create_funnel_flow_modal_form_confirm_default_flow_warning: 'There is another review flow assigned by default. Do you want to select this one as the default review flow? ',

  company_create_funnel_flow_modal_form_flow_steps: 'Flow steps',
  company_create_funnel_flow_modal_form_flow_steps_hint: 'Indicate the steps an expense must go through the aproval flow and the roles and users that will review the expense in each step of the flow.',
  company_create_funnel_flow_modal_form_flow_steps_add_step: '+ Add step',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name: 'Name',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name_placeholder: 'Step name',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers: 'Reviewer(s)',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers_placeholder: 'Search...',

  company_create_funnel_flow_modal_form_create_flow: 'Create aproval flow',
  company_create_funnel_flow_modal_form_edit_flow: 'Save changes',

  company_fetch_review_flows_error: 'Whoops! Something went wrong while trying to get the list of review flows',
  company_fetch_review_flow_error: 'Whoops! Something went wrong while trying to get this review flow Hemos tenido un problema al intentar obtener este flujo de revisión',
  company_create_review_flow_success: 'Review flow created successfully',
  company_update_review_flow_success: 'Review flow updated successfully',

  company_create_review_flow_error: 'Whoops! Something went wrong while trying to create a review flow',
  company_update_review_flow_error: 'Whoops! Something went wrong while trying to update this review flow',
  company_delete_review_flow_success: 'Review flow deleted successfully',
  company_delete_review_flow_error: 'Whoops! Something went wrong while tryign to delete this review flow',

  /* Integrations */
  company_integrations_settings_information:
    "Here you will find the neccessary settings in order to work with your other platforms (ERPs) . If you can't find it, you may recommend integrations in the suggestions box on the list",
  company_integrations_suggest_integration: 'Suggestions?',
  company_integrations_suggest_integration_comment: 'Recommend us an integration!',
  company_intragrations_settings_config_updated_success: 'Configuration has been updated successfully',

  /* -- Integrations: Holded */
  company_integrations_settings_holded_payment_account_number:
    'Payment account number',

  /* Export Settings */
  company_export_settings_information: 'In this section you can set up everything you need to export transaction and refund information to your accounting software.',
  company_export_settings_field_mapping_name: 'Name',
  company_export_settings_field_mapping_author: 'Author',
  company_export_settings_field_mapping_used: 'Used in',
  company_export_settings_file_format_name: 'Name',
  company_export_settings_file_format_author: 'Author',
  company_export_settings_file_format_format: 'Format',
  company_export_settings_file_format_used: 'Used in',
  company_export_settings_file_formats: 'Export format files',
  company_export_settings_new_format: 'Create new format',
  company_export_settings_field_mapping: 'Field mapping',
  company_export_settings_new_mapping: 'Create new mapping',
  company_export_settings_create_field_mapping_name: 'Name',
  company_export_settings_create_field_mapping_correspondence: 'Correspondence between taxes',
  company_export_settings_create_field_mapping_correspondence_subtitle: 'Here you can modify the values that will be used to specify taxes on export. Remember! If you dont modify it, the Fuell value will be exported.',
  company_export_settings_create_field_mapping_region: 'Region',
  company_export_settings_create_field_mapping_fuell: 'In fuell',
  company_export_settings_create_field_mapping_export: 'On export',
  company_export_settings_create_field_mapping_category: 'Category',
  company_export_settings_edit_field_mapping_modal_header: 'Edit mapping',
  company_export_settings_create_field_mapping_modal_header: 'New mapping',
  company_export_settings_edit_field_mapping_modal_confirm: 'Save',
  company_export_settings_create_field_mapping_modal_confirm: 'Save',
  company_export_settings_create_file_format_format: 'File format',
  company_export_settings_create_file_format_csv: 'CSV (Comma Separated Values)',
  company_export_settings_create_file_format_xlsx: 'XLSX (Excel)',
  export_exportation_flow_include_tickets: 'Include tickets',
  company_export_settings_create_file_format_columns: 'File columns',
  company_export_settings_create_file_format_columns_subtitle: 'Indicate the columns that you want the final file to have, indicating the data that you need to go in each of them.',
  company_export_settings_create_file_format_name: 'Name',
  company_export_settings_create_file_format_data: 'Data',
  company_export_settings_create_file_format_tag: 'Add field options',
  company_export_settings_create_file_format_example: 'Example',
  company_export_settings_create_file_format_add_column: '+ Add column',
  company_export_settings_edit_file_format_modal_header: 'Edit format',
  company_export_settings_create_file_format_modal_header: 'New format',
  company_export_settings_edit_file_format_modal_confirm: 'Save',
  company_export_settings_create_file_format_modal_confirm: 'Save',

  export_fetch_export_fields_error: 'Oops! Something went wrong when trying to fetch field mappings',
  export_fetch_file_format_error: 'Oops! Something went wrong when trying to fetch the file format',
  export_fetch_file_formats_error: 'Oops! Something went wrong when trying to fetch the file formats',
  export_update_file_format_error: 'Oops! Something went wrong updating the file format',
  export_create_file_format_error: 'Oops! Something went wrong creating the file format',
  export_delete_file_format_error: 'Oops! Something went wrong deleting the file format',
  expense_fetch_fields_mapping_error: 'Oops! Something went wrong when trying to fetch field mappings',
  expense_update_fields_mapping_error: 'Oops! Something went wrong updating the field mappings',
  expense_create_fields_mapping_error: 'Oops! Something went wrong creating the field mappings',
  expense_delete_fields_mapping_error: 'Oops! Something went wrong deleting the field mappings',
  export_update_file_format_success: 'The file format has been updated successfully',
  export_create_file_format_success: 'The file format was successfully created',
  export_delete_file_format_success: 'File format was successfully deleted',
  expense_update_fields_mapping_success: 'Field mapping has been successfully updated',
  expense_create_fields_mapping_success: 'Field mapping has been successfully updated',
  expense_delete_fields_mapping_success: 'Field mapping has been successfully created',
  export_fetch_exportation_flows_error: 'Field mapping has been successfully deleted',
  export_fetch_exportation_flow_error: 'Oops! Something went wrong when trying to fetch the export flows',
  export_update_exportation_flow_error: 'Oops! Something went wrong updating the export stream',
  export_create_exportation_flow_error: 'Oops! Something went wrong when creating the export flow',
  export_delete_exportation_flow_error: 'Oops! Something went wrong while deleting the export flow',
  export_create_export_history_error: 'Oops! Something went wrong creating the export',
  export_update_exportation_flow_success: 'The export flow has been successfully updated',
  export_create_exportation_flow_success: 'The export flow has been successfully created',
  export_delete_exportation_flow_success: 'Export flow has been successfully deleted',
  export_create_export_history_success: 'Export was successfully created',
  export_count_used_more: ' and + { quantity } more',

  /* ------------------- */
  /* Benefits - Flexible Remuneration section */
  benefits_users_table_header_employee: 'Name',
  benefits_users_table_header_meals_activated: 'Activated meals',
  benefit_users_table_header_limit: 'Meals limit',
  benefits_users_table_header_limit_meal_accumulative: 'Meals balance',
  benefit_users_table_header_limit_monthly_assigned: 'Month assignation',
  benefits_users_table_header_transport_activated: 'Activated transports',
  benefit_users_table_header_transport_limit: 'Transports limits',
  benefits_users_table_header_limit_transport_accumulative:
    'Transports balance',

  benefits_users_table_header_spent_vs_available: '% Spent vs Available',
  benefits_tab_flex_retribution: 'Flexible retribution plan',
  benefits_users_table_header_meals_current_month: 'Meals: {currentMonth}',
  benefits_users_table_header_meals_next_months: 'Meals: Following months',

  benefits_tab_flex_transactions: 'Transactions',
  benefits_export: 'Export',
  benefits_fetch_flex_budgets_error:
    ' Whoops! Something went wront while trying to get the flexible remuneration options for the user',
  benefits_max_meal_allowed_surpased:
    'You may only assign amounts lower than 220 €',
  benefits_transactions_fetch_transactions_error:
    'Whoops! Something went wront while trying to get the transactions',
  benefits_export_benefits_error:
    'Whoops! Something went wrong while trying to export the transactions',

  /* Benefits configuration */
  office_feature_not_available: 'That feature is not active for current office',
  benefits_configuration: 'Configure',

  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_NURSERY:
    'By activating this option employees will be able to make a request for flexible childcare compensation through a form that will be sent to them by Fuell. Once the user makes the request, we will notify you by email so that you can accept or deny them.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_INSURANCE:
    'By activating this option employees will be able to make a request for flexible insurance remuneration through a form that will be sent to them by Fuell. Once the user makes the request, we will notify you by email so that you can accept or deny it.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_EDUCATION:
    'By activating this option employees will be able to make a request for flexible training remuneration through a form that will be sent to them by Fuell. Once the user makes the request, we will notify you by email so that you can accept or deny it.',
  benefits_configure_benefits_header: 'Benefits configuration',
  benefits_office_setting_update_success: 'Configuration updated successfully',
  benefits_office_setting_update_error:
    'Whoops! Something went wrong while tryin to update settings',

  benefits_toggle_all_users_features_status_success:
    'All users benefits have been updated',
  benefits_toggle_all_users_features_status_error:
    'Whoops! Something went wrong while trying to update the employees benefit status',
  benefits_closure_date_invalid_value_error: 'Introduce a valid date',
  benefits_closure_data_value_not_in_range_error:
    'The selected day is invalid, introduce a number between 1 and 31',
  benefits_closure_date_set_success: 'The closure date has been set correctly',
  benefits_set_closure_date_error:
    'Whoops! Something went wrong while trying to set the closure date',
  benefits_configuration_benefits_closure_date: 'Day of month',
  benefits_budget_benefit_reset_warning:
    'Indicate the day of the month in which de benefits will be reseted for employers',
  benefits_configuration_setting_activate_on_all_users:
    'Activate for all users',
  benefits_configuration_configure_features_for_all_users_warning:
    'If the anual gross salary has not been set for an employer, the feature will not be activated for that employer. You may indicate anual gross salary in the Users section. When activated, we will assign an aproximation to the legal maximun amount possible for the user.',
  benefits_configuration_setting_personalize_time_restrictions:
    'Restrict times',
  benefits_configuration_settings_accumulative_benefits:
    'Accumulative flexible remuneration',
  benefits_configuration_settings_accumulative_benefits_explanation:
    'If activated, the amount of money not spent will be added to the next month balance',

  benefits_configuration_settings_activate_accumulative_benefits:
    'Activate accumulative flexible remuneration for the users',
  benefits_confirm_ret_flex_deactivation_with_accumulative_benefits:
    'Disable accumulative flexible remuneration for this user',
  benefits_confirm_acumulation_removal_warning:
    'The user has {balance}€ and if you disable the feature, the user will not be able to use that money. Instead of disabling the feature, you may set the Monthly assingation to 0  from now on, so that the user can access his {balance}, and no money is added to his balance for the next months',
  benefits_confirm_acumulation_setting_removal_office_warning:
    'It is possible that you may have employees with an accumulated balance and if you disable this, they will not be able to use it. Instead of switching off, you may set ther monthly assignation to 0€ so that it will not be added to their balance and they can still have access to it. Do you still want to continue ?',
  benefits_confirm_acumulation_removal_action_confirm:
    'Yes, I want to disable accumulative flexible remuneration',
  benefits_confirm_subvention_deactivation_with_accumulative_subvention:
    'Disable accumulative subvention for this user',
  benefits_confirm_acumulation_remove_warning:
    'This user has funds in any of the active subventions and if you disable this, they will not be able to use it. Instead of switching it off, you may set the monthly assignation to 0€ so that it will not be added to theri balance, and they can still have access to it. Do you still want to continue?',

  snackbars_insurance_policy_holders_warning:
    'You must indicate any insurance policy holder in order to change assignation',

  /* - Benefits time restrictions configuration - */
  benefits_configure_time_restrictions: 'Set time restrictions',
  benefits_header_time_restrictions: 'Time restrictions for benefits',
  benefits_configuration_settings_time_restrictions_from_label:
    'Start time of use of benefits',
  benefits_configuration_settings_time_restrictions_to_label:
    'End time of use of benefits',
  benefits_time_restrictions_configuration_modal: 'Configure time restrictions',
  benefits_configuration_settings_time_restrictions:
    'Configue users time restrictions',
  benefits_configurations_settings_time_restrictions_warning:
    'You may set a time schedule in which users can use restaurants and transports benefits, The spanish law (Real Decreto 439/2007) indicates that the restaurant service is only possible during the user working  days',
  benefits_configurations_time_restrictions_weekdays:
    'Days in which benefits may be used',
  benefits_configurations_time_restrictions_restricted_time:
    'Times in which benefits may be used',
  benefits_configuration_time_restrictions_success:
    'The time restrictions have been updated successfully',
  benefits_configuration_time_restrictions_error:
    'Whoops! Something went wrong while trying to update the time restrictions',
  benefits_configuration_time_from_after_to:
    'Start time cannot be after end of use time',
  benefits_configuration_time_to_before_from:
    'End time cannot be before start of use time',

  /* Flexible remuneration types */
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_MEAL:
    'Flexible remuneration for meals',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_TRANSPORT:
    'Flexible remuneration for transport',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_NURSERY:
    'Flexible remuneration for nursery',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_EDUCATION:
    'Flexible remuneration for training',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_INSURANCE:
    'Flexible remuneration for insurance',

  benefits_configuration_closure_date_note: 'Note: ',
  benefits_configuration_closure_date_last_closure:
    'the last closure date was: {lastClosureDate}, ',
  benefits_configuration_closure_date_next_closure:
    'the next closure date is: {nextClosureDate}.',
  benefits_table_header_current_month_fallback: 'Month in progress',

  export_fields_InvoiceNumberLabel: 'Invoice number',
  export_fields_expenseDateLabel: 'Date of expense',
  export_fields_expenseHourLabel: 'Time of expense',
  export_fields_balanceLabel: 'Balance',
  export_fields_currencyBalanceLabel: 'Currency',
  export_fields_amountSettledLabel: 'Amount paid',
  export_fields_currencySettledLabel: 'Original currency',
  export_fields_amountApprovedLabel: 'Amount approved',
  export_fields_currencyApprovedLabel: 'Currency approved',
  export_fields_merchantNameLabel: 'Merchant',
  export_fields_businessNameNameLabel: 'Company',
  export_fields_merchantIdLabel: 'Merchant Id',
  export_fields_merchantAddressLabel: 'Business Address',
  export_fields_merchantZipCodeLabel: 'Merchant Zip Code',
  export_fields_merchantProvinceLabel: 'Commerce Province',
  export_fields_merchantRegionLabel: 'Merchant Region',
  export_fields_merchantCountryLabel: 'merchantCountry',
  export_fields_taxationCountryLabel: 'Country VAT',
  export_fields_employeeNameLabel: 'EmployeeName',
  export_fields_originalCategoryLabel: 'Category',
  export_fields_subCategoryLabel: 'Subcategory',
  export_fields_codeCategoryLabel: 'Category code',
  export_fields_noteLabel: 'Note',
  export_fields_reviewStatusLabel: 'Reviewed',
  export_fields_mediaLabel: 'Media',
  export_fields_originalTaxLabel: 'VAT type',
  export_fields_netAmountLabel: 'VAT',
  export_fields_taxAmountLabel: 'VAT amount',
  export_fields_grossAmountLabel: 'Gross amount',
  export_fields_budgetNameLabel: 'Budget Name',
  export_fields_paymentMethodCodeLabel: 'Payment method',
  export_fields_refundableLabel: 'Refundable',
  export_fields_isReceiptLabel: 'Is receipt?',
  export_fields_transactionStatusLabel: 'Status',
  export_fields_receiptTypeLabel: 'Receipt or invoice',
  export_fields_expenseCreatedAtLabel: 'Date expense created',
  export_fields_receiptNumberLabel: 'Receipt number',
  export_fields_employeeIdentifierLabel: 'Employee identifier',
  export_fields_employeeExpenseCenterLabel: 'Expense Center',
  export_fields_transactionCreatedAtLabel: 'Transaction creation date',
  export_fields_transactionReviewedAtLabel: 'Date reviewed',
  export_fields_creditAmountLabel: 'Credit',
  export_fields_debitAmountLabel: 'Debit',
  export_fields_IVALabel: 'VAT',
  export_fields_grossAmountEuroLabel: 'Gross amount €',
  export_fields_confirmationDateLabel: 'Confirmation date',
  export_fields_export_fields_confirmationDateLabel: 'Date value',
  export_fields_mediaLinkLabel: 'Media link',
  export_fields_transactionIdLabel: 'Expense id',
  export_fields_taxType1Label: 'Tax rate 1',
  export_fields_taxBase1Label: 'Tax base 1',
  export_fields_vat1Label: 'Tax amount 1',
  export_fields_taxType2Label: 'Tax rate 2',
  export_fields_taxBase2Label: 'Tax base 2',
  export_fields_vat2Label: 'Tax amount 2',
  export_fields_taxType3Label: 'Tax rate 3',
  export_fields_taxBase3Label: 'Tax base 3',
  export_fields_vat3Label: 'Tax amount 3',
  export_fields_taxType4Label: 'Tax rate 4',
  export_fields_taxBase4Label: 'Tax base 4',
  export_fields_vat4Label: 'Tax amount 4',
  export_fields_taxType5Label: 'Tax rate 5',
  export_fields_taxBase5Label: 'Tax base 5',
  export_fields_vat5Label: 'Tax amount 5',
  export_fields_taxType6Label: 'Tax rate 6',
  export_fields_taxBase6Label: 'Tax base 6',
  export_fields_vat6Label: 'Tax amount 6',
  export_fields_budgetField1Label: 'Budget field 1',
  export_fields_budgetField2Label: 'Budget field 2',
  export_fields_budgetField3Label: 'Budget field 3',
  export_fields_userDocumentLabel: 'User ID',
  export_fields_vatTypeCodeLabel: 'Tax code',
  /* EXPORT FLOW */
  exports_create_export_flow_title: 'You do not have any export flows yet',
  exports_create_export_flow_subtitle: 'Flows are the way to configure an export to make it easier for you to do it on a recurring basis. We are going to create the first one. Do not worry, fortunately it is very simple.',
  exports_create_export_flow_button: 'Create exportation',
  export_exportation_flow_name: 'Name',
  export_exportation_flow_exportation_system: 'Exportation system',
  export_exportation_flow_exportation_system_subtitle: 'Choose where the export data will end up.',
  export_exportation_flow_erp: 'Connected ERP',
  export_exportation_flow_erp_placeholder: 'ERP',
  export_exportation_flow_destination_file: 'Destination file',
  export_exportation_flow_field_mapping: 'Field mapping',
  export_exportation_flow_field_mapping_subtitle: 'What field mapping will be used?',
  export_exportation_flow_field_mapping_placeholder: 'Select from list',
  export_exportation_flow_field_mapping_empty: 'Do not use field mapping',
  export_exportation_flow_historical: 'Export history',
  export_exportation_flow_historical_description: 'Maintain export history',
  export_exportation_flow_historical_info: 'By ticking this box you will not be shown the expenses that have been exported before',
  export_exportation_flow_entities_to_export: 'Entities to export',
  export_exportation_flow_entities_to_export_NORMAL: 'Transactions',
  export_exportation_flow_entities_to_export_EXPENSE: 'Refunds',
  export_exportation_flow_initial_filters: 'Initial filters',
  export_exportation_flow_initial_filters_subtitle: 'Do you want to apply a filter by default when accessing the export flow?',
  export_exportation_flow_initial_filters_ALL: 'All',
  export_exportation_flow_initial_filters_DENIED: 'Denied',
  export_exportation_flow_initial_filters_COMPLETED: 'Completed',
  export_exportation_flow_initial_filters_APPROVED: 'Approved',
  export_exportation_flow_initial_filters_PERSONAL_EXPENSES: 'Personal expenses',
  export_exportation_flow_initial_filters_MISSING_INFO: 'Missing info',
  export_exportation_flow_initial_filters_SEND_FOR_REVIEW: 'In review',
  export_exportation_flow_initial_filters_DENIED_PERSONAL_EXPENSES: 'Denied/Personal expenses',
  export_exportation_flow_date: 'Date',
  export_exportation_flow_clear_dates: 'Clear date selection',
  export_exportation_flow_user_search: 'Select one or more from the list',
  export_exportation_flow_budget_search: 'Select one or more from the list',
  export_exportation_flow_file_format: 'Template',
  export_edit_exportation_flow_modal_header: 'Modify exportation flow',
  export_create_exportation_flow_modal_header: 'New exportation flow',
  export_edit_exportation_flow_modal_confirm: 'Save',
  export_create_exportation_flow_modal_confirm: 'Save',
  export_exportation_flow_tabs_all: 'All',
  export_exportation_flow_tabs_transactions: 'Transactions',
  export_exportation_flow_tabs_expenses: 'Refunds',
  export_exportation_flow_using: 'Export using',
  export_exportation_flow_using_placeholder: 'Select export flow',
  export_flow_create_export_flow: '+ New export flow',
  export_flow_modify: 'Modify',
  export_flow_export: 'Export',
  export_exportation_flow_exported: 'Go to Exported',
  export_flow_exported_date: 'Date',
  export_flow_exported_exportation: 'Go to Exportation',
  export_flow_exported_file: 'File',
  export_flow_exported_filters: 'Filters',
  export_flow_exported_format: 'Format',
  export_flow_exported_status: 'Status',
  export_exportation_flow_translate_filters_completed: 'Completed',
  export_exportation_flow_translate_filters_status: 'Status: ',
  export_exportation_flow_translate_filters_status_CANCELLED: 'Cancelled ',
  export_exportation_flow_translate_filters_status_APPROVED: 'Approved ',
  export_exportation_flow_translate_filters_personal_expense: 'Personnel Expenditure',
  export_exportation_flow_translate_filters_date: 'Date: ',
  export_exportation_flow_translate_filters_entity_NORMAL: 'Entity: Transactions',
  export_exportation_flow_translate_filters_entity_EXPENSE: 'Entity: Expenses',
  export_exportation_flow_translate_filters_entity_ALL: 'Entities: transactions and expenses',
  export_exportation_flow_translate_filters_budget: 'Budget: ',
  export_exportation_flow_translate_filters_user: 'Users: ',

  /* -------------- */
  /* - MERCHANT SETTINGS - */
  merchant_settings_merchant_settings_tab: 'Merchants',
  merchant_settings_actitvy_groups_settings_tab: 'Activity groups',
  merchant_settings_merchant_create_button: 'New merchant',

  /* - Merchant Settings Table - */
  merchant_merchant_name: 'Display name',
  merchant_merchant_social_reason: 'Social reason',
  merchant_merchant_matchers: 'Matchers',
  merchant_merchant_add_matcher: 'Add matcher',
  merchant_merchant_cif: ' CIF',
  merchant_merchant_identifiers: 'Internal IDs',

  /* - Merchant details  - */
  merchants_merchant_detail_header: 'Merchant settings',
  merchants_fetch_merchant_error:
    "Whoops! Something went wront while trying to fetch the merchants' information",
  merchants_update_logo_success: 'Merchant logo updated successfully',
  merchants_update_logo_error:
    "Whoops! Something went wrong while trying to update this merchant's logo ",
  merchants_update_merchant_success: 'Merchant updated successfully',
  merchants_update_merchant_error:
    'Whoops! Something went wrong while trying to update this merchant',
  merchants_create_merchant_success: 'Merchant created successfully',
  merchants_create_merchant_error:
    'Whoops! Something went wrong while trying to create this merchant',
  merchant_merchant_matcher_text: 'Contains text',
  merchant_merchant_matcher_text_case_insensitive_info: 'Case-insensitive',

  /* -------------- */
  network_error_message:
    'Whoops! Looks like we have some problems trying to connect, try again in a few moments  or reload the webpage',

  /* - GENERIC TERMS  --- */
  file_input_select_browse: 'Browse',
  file_input_select_file: 'Select Files...',
  file_input_amount_files_selected: '{amount} files selected',
  media_viewer_fetch_resource: 'Download',
  media_viewer_fetching_resource: 'Downloading...',
  media_viewer_delete_resource: 'Delete',
  media_viewer_deleting_resource: 'Deleting...',
  date_picker_input_placeholder: 'Select date range',
  date_picker_input_range_selector_placeholder:
    'Click and select start and end date',
  date_picker_input_range_selector_range_selected:
    'From {startDate} to {endDate} (both included)',
  date_picker_select_range_selector_range_selected: '{startDate} to {endDate}',
  date_select_last_seven_days: 'Last 7 days',
  date_select_personalized_range: 'Custom date range',
  date_select_personalized_range_from_to: 'to',
  date_select_this_month: 'Current month',
  date_select_last_month: 'Last month',
  date_select_this_year: 'Current year',
  date_picker_input_expiration_date_select_default_date: 'No Expiration',
  date_picker_input_transaction_date_range_selector:
    'Select a transaction date range',
  date_picker_input_from: 'From',
  date_picker_input_to: 'To',
  date_picker_input_placeholder_mask: 'MM/DD/YYY',
  date_invalid_error: 'Please indicate a valid date',
  snackbar_launch_intercom_message: 'Ask for help by chat now',
  intercom_predefined_error_message:
    'Hello, I received the following error message : " {errorMessage} ", can you help me ?',
  intercom_predefined_error_message_with_route:
    'Hello, I received the following error message: {errorMessage}, while I was in this address: { routerUrl}  can you help me ?',
  intercom_reset_passcode_message:
    'Hello, I need to recover my passcode, can you help me?',
  intercom_open_conversation: 'Contact by chat',
  intercom_message_variation_message:
    'If you need assistance, contact us by chat.',
  multiselect_no_options_slot_default: 'No options found',
  multiselect_no_result_slot_default: 'No results were foudn, try again',
  multiselect_no_users_found: 'No users were found',
  multiselect_no_users: 'No users available',
  multiselect_no_accounting_periods: 'No accounting periods available',
  multiselect_no_budgets_found: 'No budgets were found',
  multiselect_no_budgets: 'No budgets have been created',
  multiselect_no_categories_found: 'No categories were found',
  multiselect_limit_text: 'and {count} more',
  error_handler_violation_field_message: '{fieldName}',
  route_redirection_role_notification:
    "You don't have permission to acces the specified route",
  keyword_to_range: 'to',
  /* ------- */
  /* - Validation Generic Messages - */
  validations_password_mismatch: "Passwords doesn't match!",
  /* ------ */
  /* - Confirm Modal Text - */
  confirm_modal_title: 'Are you sure?',
  confirm_modal_message: "Are you sure? This action can't be undone",
  confirm_modal_accept_button_text: 'Yes',
  confirm_modal_dismiss_button_text: 'Cancel',
  /* ------ */
  /* Activity Groups */
  activity_group__RESTAURANTS: 'meals',
  activity_group__TRANSPORT: 'transport',
  activity_group__INSURANCE: 'insurance',
  activity_group__NURSERY: 'nursery',
  activity_group__EDUCATION: 'education',
  activity_group__OTHERS: 'others',

  /* -- Card Usage Types -- */
  office_card_usage_type__OFFICE_CARDS_ALWAYS: 'Users with cards',
  office_card_usage_type__OFFICE_CARDS_WITHOUT: 'Users without cards',
  office_card_usage_type__OFFICE_CARDS_OPTIONAL: 'Users with optional cards',
  user_card_usage_type__USER_CARDS_ALWAYS: 'Request card',
  user_card_usage_type__USER_CARDS_WITHOUT: "Don't request card",
  user_card_usage_not_applicable: 'Not applicable',
  user_card_usage_type__PHYSICAL: 'Physical card',
  user_card_usage_type__VIRTUAL: 'Virtual card',

  /* -- Customer Statuses -- */
  customer_status__ACTIVE: 'Active',
  customer_status__ARCHIVE: 'Archived',
  customer_status__KYB_REJECTED: 'KYB rejected',
  customer_status__ONBOARDING_PENDING: 'Onboarding pending',
  customer_status__VALIDATION_PENDING: 'Validation pending',

  /* - Country Names- */
  Spain: 'Spain',
  USA: 'USA',
  country_name_Spain: 'Spain',
  country_name_USA: 'USA',

  section_title_active_customers: 'Customers',
  section_title_transactions_pending: 'Transactions',
  section_title_benefit_transactions: 'Benefits',
  section_title_my_history_reimbursements_breadcrumb: 'Refund history',
  section_title_my_charged_transactions_breadcrumb: 'Charged transactions',
  section_title_my_authorizations_transactions_breadcrumb: 'Authorizations',
  section_title_my_declined_transactions_breadcrumb: 'Denied transactions',
  section_title_my_pending_reimbursements_breadcrumb: 'Pending review',
  login_change_passcode_form_submit: 'Change passcode',
  login_change_passcode_action_change_passcode: 'Change passcode',

  login_change_passcode_action_return_to_dashboard: 'Return to main dashboard',
  login_change_passcode_form_information: 'Hello {userName}, to change your password, please fill in the information requested',
  login_change_passcode_input_new_passcode: 'Enter your new password',
  login_change_passcode_input_repeat_passcode: 'Re-enter your new password',
  login_change_passcode_invalid_token_error: 'Cannot perform the password change, you either have to log in with the user that requested the change or the reset link has expired',
  login_change_passcode_success_with_redirect: 'The password has been changed successfully, you will be redirected to the main panel shortly',
  user_request_reset_passcode_success: 'We have sent you an email to change your password',
  dashboard_account_box_available: 'current balance',
  dashboard_account_box_make_payment_action: 'Add money',
  dashboard_graphic_header: 'Evolution of expenses',
  dashboard_graphic_header_budgets: 'Evolution of expenses (by budgets)',
  dashboard_graphic_header_categories: 'Evolution of expenses (by categories)',
  dashboard_time_selector_modal_header: 'Select custom date range',
  date_picker_input_range_selector: 'Date range',
  dashboard_fetch_expense_dashboard_data_error: 'Oops! Something went wrong while trying to get the data for the charts',
  users_import_users_download_template: 'download this template',
  customers_tabs_customer: 'Customers',
  customers_tabs_users: 'Users',
  customer_data_error: 'We had a problem obtaining customer information',
  office_features_activation: 'Activate features',
  office_feature_activate_rf: 'Activate Flexible Compensation',
  office_feature_activate_benefits: 'Activate Social Benefit',
  office_feature_activate_devoluiva: 'Activate Devoluiva',
  office_feature_rf_activated: 'Flexible remuneration activated',
  office_feature_bf_activated: 'Benefits activated',
  office_feature_devoluiva_activated: ' Devoluiva activated',
  office_feature_activate_rf_header: 'Activate Flexible Compensation',
  office_feature_warning: 'You are about to activate feature {featureName}, for company {customerName}. {featureWarningDanger}, so please confirm the details of the company to be activated and press confirm',
  office_feature_warning_danger: 'This feature cannot be easily deactivated',
  office_feature_activation_success: 'The feature has been successfully activated',
  office_feature_feature_not_found_error: 'The feature to be activated was not found, please try again later',

  office_feature_activation_error: 'Oops! We had a problem trying to activate this feature',
  confirm_save_changes_modal: 'Save changes',
  confirm_save_changes_modal_message: 'Are you sure to save changes? This configuration will affect the whole company',
  confirm_close_save_changes_modal: 'Close window',
  confirm_close_save_changes_modal_message: 'Are you sure to close the window? The changes you have made will not be applied',

  manage_office_features_header: 'Manage features',
  manage_office_feature_FLEXIBLE_REMUNERATION: 'Flexible remuneration',
  manage_office_feature_SUBVENTION_FEATURE: 'Social benefits',
  manage_office_feature_EXPORT_FUNNEL_FEATURE: 'Customised export',
  manage_office_feature_MULTI_CURRENCIES_FEATURE: 'Multicurrency',
  manage_office_feature_WATERMARK: 'Watermark',
  manage_office_feature_OWNER_INVITE_USER: 'Budget owners can invite',
  manage_office_feature_AUTO_EXCHANGE: 'Auto exchange',
  manage_office_feature_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'Edit does not restart revision',
  manage_office_feature_DEVOLUIVA: 'DevoluIVA',
  manage_office_feature_MANUAL_EXPENSES_REIMBURSE: 'Allow the creation of refunds',
  manage_office_feature_SHOW_BUDGET_FIELDS: 'Add extra budget fields',
  manage_office_feature_tooltip_AUTO_EXCHANGE: 'When activated, the amount of the expense and the amount in the original currency always take the information from what the OCR reads',
  manage_office_feature_tooltip_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'If active, when an expense is edited and is in an approval flow, it is not returned to the first step of the approval flow.',
  manage_office_feature_tooltip_MANUAL_EXPENSES_REIMBURSE: 'If active, companies will be able to create refunds manually when they create an expense',
  user_self_onboarding_create_account_signup_here: 'Sign up here',
  user_invitation_form_fuell_payment_provider_terms_header: 'Terms of payment services',
  user_invitation_form_fuell_payment_provider_terms_explanation: 'Payment Service Provider Terms and Conditions',
  user_profile_change_passcode_instructions_warning: 'This will change your passcode, not your card PIN',
  user_profile_change_passcode_step_one: 'Enter your current passcode',
  user_profile_change_passcode_step_two: 'Enter your new password',
  user_profile_change_passcode_step_three: 'Confirm your new password',
  user_profile_change_passcode_success: 'Password updated',
  user_profile_forgot_passcode_confirm_request_reset_passcode: 'Send email',
  user_profile_forgot_passcode_message: 'We will send you an email to change your password',
  user_profile_settings_email: 'Email',
  user_profile_settings_mobile: 'App',
  transactions_transactions_subsection_pending: 'Pending',
  transactions_transactions_subsections_history: 'History',
  transactions_action_close_accounting_periods: 'Accounting closure',
  transactions_action_close_accounting_periods_title: 'Confirm accounting closure',

  transactions_categorize_status__PENDING: 'Pending',
  transactions_card_type__BUDGET_VIRTUAL: 'Virtual Card',
  transactions_charged_table_header_receipt_number: 'Receipt number',
  transactions_charged_table_header_category: 'Category',
  transactions_charged_table_header_subcategory: 'Subcategory',
  transactions_charged_table_header_expense_date: 'Expense date',
  transactions_charged_table_header_reviewed_date: 'Approval date',
  transactions_charged_table_header_provider: 'Company name',
  transactions_charged_table_header_provider_data: 'VAT number',
  transactions_export_default_users_format: 'Normal format broken down by users',
  transactions_edit_transaction_tax_region_selector: 'Taxation region',
  transaction_edit_address: 'Address',
  transaction_edit_zip_code: 'Zip code',
  transaction_edit_city: 'City',
  transaction_edit_state: 'Province',
  transaction_edit_country: 'Country',
  transactions_fetch_vat_types_error: 'Oops! Something went wrong getting the list of tax regions',
  expenses_receipts_modal_header: 'Expense receipts',
  expenses_receipt_modal_body: 'These are the resources that will be associated with the expense',
  expenses_receipt_modal_body_zero_results: 'There are no receipts for this expense',
  transactions_review_transaction_success: 'Transaction marked as successfully reviewed',
  transactions_review_status_send_for_review: 'In review',
  transactions_funnel_actions_lock: 'Lock',
  transactions_funnel_actions_unlock: 'Unlock',
  transactions_funnel_actions_account: 'Unaccount',
  transactions_funnel_actions_approve_undo: 'Unapprove',
  transactions_reject_selected_transactions_success: 'Transactions have been marked as successfully rejected',
  transactions_reject_selected_transactions_error: 'Oops! We had a problem marking transactions as rejected',
  transactions_mark_as_review_in_progress: 'Marking as reviewed...',
  transactions_mark_as_unreview_in_progress: 'Removing mark as reviewed...',
  transactions_total_transactions_selected: 'You have selected {selectedTransactions} {transactionType}',
  transactions_total_users_selected:
    'You have selected the expenses of {selectedUsers} user(s)',
  budgets_budget_cycle_selector: 'Budget periodicity',
  budget_actions_budget_settings: 'Budget Settings',
  budget_actions_archive_budget: 'Archive Budget',
  cards_budget_cards_section_tab: 'Budget Cards',
  cards_physical_cards_section_tab: 'Physical cards',
  cards_virtual_cards_section_tab: 'Virtual cards',
  cards_all_cards_section_tab: 'All',
  cards_detail_spent: 'spent this month',
  card_action_request_passcode: 'Enter your password',
  card_action_input_passcode: 'For security reasons, please enter your password to continue',
  cards_action_fetch_cards_error: 'Oops! Something went wrong while trying to fetch the card list',
  cards_action_activate_card_success: 'Card successfully activated',
  cards_action_freeze_card_success: 'Card successfully frozen',
  cards_action_activate_card_error: 'Oops! Something went wrong activating the card',
  cards_action_freeze_card_error: 'Oops! Something went wrong when freezing the card',
  expense_fields_diet_categories: 'Dietary categories',
  expense_fetch_mileage_categories_error: 'Oops! Something went wrong while trying to fetch mileage categories',
  company_update_mileage_category_success: 'Mileage category has been updated successfully',
  company_update_mileage_category_error: 'Oops! Something went wrong while trying to update the mileage category',
  company_create_mileage_category_success: 'Mileage category was created successfully',
  company_create_mileage_category_error: 'Oops! Something went wrong while trying to create the mileage category',
  company_delete_mileage_category_success: 'Mileage category was deleted successfully',
  company_delete_mileage_category_error: 'Oops! Something went wrong while trying to create the mileage category',
  company_create_diet_category_amount: 'Amount',
  benefits_users_table_header_nursery_assignation: 'Nursery: assignment',
  benefits_tab_social_benefits: 'Social benefits (recurring)',
  benefits_export_benefits_select_period: 'Select period to export',
  benefits_export_select_period: 'Period',
  benefits_fetch_export_periods_error: 'Oops! Something went wrong when trying to get the export periods',
  benefits_configuration_activate_feature: 'Allow to make request to all users',
  benefits_users_table_header_subvention_status: 'Social benefit activated',
  benefits_users_table_header_transport_current_month: 'Transportation: {currentMonth}',
  benefits_users_table_header_transport_next_months: 'Transportation: next months',
  benefits_users_table_header_nursery_status: 'Nursery activated',
  benefits_users_table_header_insurance_status: 'Insurance activated',

  benefits_users_table_header_insurance_disabled_policy_holders: 'Insurance: disabled policy holders',
  benefits_users_table_header_insurance_education_status: 'Training: enabled',

  benefits_users_table_header_insurance_assignation: 'Insurance: assigned',
  benefits_users_table_header_insurance_education_assignation: 'Training:assigned',
  benefits_users_table_header_insurance_policy_holders: 'Insurance: policy holders',

  merchants_activity_group_header_name: 'Name',
  merchants_fetch_activity_groups_error: 'Oops! We had a problem fetching the activity group listing',
  merchants_activity_group_detail: 'Activity group detail',
  merchants_activity_group_name: 'Name',
  merchants_activity_group_national_codes: 'National codes',
  merchants_activity_group_international_codes: 'International codes',
  merchants_fetch_activity_group_error: 'Oops! We had a problem trying to get the detail of this activity group',
  merchants_update_activity_group_logo_success: 'Activity group logo updated successfully',
  merchants_update_activity_group_logo_error: 'Oops! We had a problem updating the activity group logo',
  superadmin_generate_otp_success: 'A One Time Password has been sent to your phone, check your SMS',
  superadmin_generate_otp_error: 'Oops! We had a problem trying to generate your one time password, please try again',
  superadmin_make_admin_confirm_title: 'This action is not reversible, do you want to continue?',
  superadmin_make_admin_success: 'This user is now admin',
  superadmin_make_admin_error: 'This user could not be made admin',
  intercom_import_users_message: 'Hi, I need help importing users, can you give me a hand',
  multiselect_accounting_period_not_found: 'No period found',
  multiselect_payment_method_not_found: 'No payment methods found',
  multiselect_no_payment_methods: 'No payment methods found',
  day_of_week_0: 'Monday',
  day_of_week_1: 'Tuesday',
  day_of_week_2: 'Wednesday',
  day_of_week_3: 'Thursday',
  day_of_week_4: 'Friday',
  day_of_week_5: 'Saturday',
  day_of_week_6: 'Sunday',
  day_of_week_MONDAY: 'Monday',
  day_of_week_TUESDAY: 'Tuesday',
  day_of_week_WEDNESDAY: 'Wednesday',
  day_of_week_THURSDAY: 'Thursday',
  day_of_week_FRIDAY: 'Friday',
  day_of_week_SATURDAY: 'Saturday',
  day_of_week_SUNDAY: 'Sunday',

  /* CURRENCIES */
  currencies_EUR: 'EUR - EU Euro',
  currencies_GBP: 'GBP - British pound',
  currencies_USD: 'USD - US Dollar',
  currencies_ARS: 'ARS - Argentine peso',

  /* Other terms */
  EXPENSE: 'Expenses',
  REIMBURSEMENT: 'Expenses',
  TRANSACTION: 'Transactions',
  DIET: 'Diet',
  MILEAGE: 'Mileage',
  snackbar_sanitizing_error: 'An invalid character has been introduced, please remove it and try again',

  /* static pages */
  privacy_policy_page: 'https://www.getfuell.com/privacy-policy',
  terms_conditions_page: 'https://www.getfuell.com/terms-and-conditions',
  special_conditions_services_page: 'https://www.getfuell.com/special-conditions-of-services',
  payment_terms_page: 'https://www.getfuell.com/payment-service-provider-terms-and-conditions',

  // terms and conditions
  terms_conditions_title: 'Updated terms and conditions',
  terms_conditions_description: 'We have updated our terms and conditions. You can view the full document at the following {tc}.',
  terms_conditions_description_link_text: 'link',
  terms_conditions_label: 'I have read and accept the new Terms and Conditions',
  terms_conditions_accept: 'Confirm',

  /* alerts modal */
  alerts_modal_title: 'Alerts',
  alerts_modal_duplicated: 'Alert for duplicated expense',
  alerts_modal_duplicated_description: 'We will alert you if we detect any duplicated expenses. You will always have the ability to review the expenses and ignore the alert',
  alerts_modal_empty_receipt: 'Alert for missing receipt',
  alerts_modal_empty_receipt_description: 'We will alert you if any expense uploaded to the platform does not have an associated receipt',
  alerts_modal_out_of_office: 'Spending hours',
  alerts_modal_out_of_office_description: 'Define the hours during which employees can incur business expenses. If any are made outside these hours we will notify you',
  alerts_modal_amount_exceeded: 'Alert for amount exceeded',
  alerts_modal_amount_exceeded_description: 'You can define maximum amounts according to the type of expense. If any expense exceeds that amount we will alert you',
  alerts_modal_AMOUNT_EXCEEDED_TRANSACTION: 'Expense',
  alerts_modal_AMOUNT_EXCEEDED_EXPENSE: 'Expense',
  alerts_modal_AMOUNT_EXCEEDED_MILEAGE_TYPE: 'Mileage',
  alerts_modal_AMOUNT_EXCEEDED_DIET: 'Diet',
  alerts_modal_amount_distinct_ocr: 'Alert for reading a different amount',
  alerts_modal_amount_distinct_ocr_description: 'If our OCR reads a different amount on the receipt to the transaction value or to the amount entered by the employee on the expense, we will alert you.',
  alerts_modal_amount_distinct_sum_taxes: 'Alert for incorrect tax',
  alerts_modal_amount_distinct_sum_taxes_description: 'If the tax breakdowon with their associated VATs do not match the expense amount we will notify you.',

  company_update_alerts_settings_error: 'Oops! We had a problem updating this type of alert.',
  /* Drag and drop  */
  dropzone_drag_and_drop_files_info: 'Drag and drop your tickets',
  dropzone_drag_and_drop_files_upload_count: 'Uploading {fileCount} tickets...'

}
